{
  "badges.sage.com": {
    "title": "Sage Digital Badges",
    "description": "Sage is the market leader for integrated accounting, payroll, and payment systems, supporting the ambition of the world’s entrepreneurs.",
    "identity": "Badges Sage",
    "languages": ["en", "en-gb", "de", "es", "fr"],
    "spiderable": "all",
    "image": "/assets/themes/badges.sage.com/images/seo_image.png",
    "twitterSite": "@sagegroupplc",
    "twitterCreator": "@sagegroupplc",
    "app": "recipient-portal",
    "recipientPortalUrls": ["badges.sage.com"],
    "spotlightUrl": "credentialdirectory.sage.com"
  },
  "credential.net": {
    "title": "Accredible • Certificates, Badges and Blockchain",
    "description": "Home of digital credentials",
    "identity": "Credential.net",
    "spiderable": "all",
    "image": "/assets/themes/credential.net/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credential.net"],
    "spotlightUrl": null
  },
  "dashboard.accredible.com": {
    "title": "Accredible Dashboard",
    "description": "Dashboard",
    "identity": "Accredible",
    "spiderable": "all",
    "app": "dashboard"
  },
  "certificates.blackhat.com": {
    "title": "Black Hat",
    "description": "Black Hat",
    "identity": "Black Hat",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@BlackHatEvents",
    "twitterCreator": "@BlackHatEvents",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certificates.blackhat.com"],
    "spotlightUrl": null
  },
  "skillsoft.digitalbadges.skillsoft.com": {
    "title": "SkillSoft Digital Badges",
    "description": "SkillSoft digital badges offer validation of learners’ skills and official recognition of their accomplishments. Learners earn, collect, and share them with managers and peers, along with professional and personal social networks.",
    "identity": "SkillSoft",
    "spiderable": "all",
    "image": "/assets/themes/skillsoft.digitalbadges.skillsoft.com/skillsoft_share.png",
    "twitterSite": "@Skillsoft",
    "twitterCreator": "@Skillsoft",
    "app": "recipient-portal",
    "recipientPortalUrls": [
      "skillsoft.digitalbadges.skillsoft.com",
      "skillsoft.digitalbadges-eu.skillsoft.com"
    ],
    "spotlightUrl": null
  },
  "credentials.advance-he.ac.uk": {
    "title": "Credentials Advance HE",
    "description": "Helping HE shape its future",
    "identity": "Advance HE",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@AdvanceHE",
    "twitterCreator": "@AdvanceHE",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.advance-he.ac.uk"],
    "spotlightUrl": null
  },
  "credential.accredible.com": {
    "title": "ACME",
    "description": "The Association for Computing and Mathematical Excellence is dedicated to promoting and recognising achievement in the field of computing and computational science.",
    "identity": "Association for Computing and Mathematical Excellence",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credential.accredible.com"],
    "spotlightUrl": "employment.accredible.com"
  },
  "credentials.intercom.com": {
    "title": "Conversational Relationship Platform",
    "description": "Build better customer relationships through conversational, messenger-based experiences with Intercom.",
    "identity": "Intercom",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentials.intercom.com/images/seo_image.png",
    "twitterSite": "@Intercomacademy",
    "twitterCreator": "@Intercomacademy",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.intercom.com"],
    "spotlightUrl": "directory.intercom.com"
  },
  "theme-preview": {
    "title": "theme-preview",
    "description": "theme-preview",
    "identity": "theme-preview",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "theme-preview",
    "twitterCreator": "theme-preview",
    "app": "recipient-portal"
  },
  "badges.theamericancollege.edu": {
    "title": "American College of Financial Services",
    "description": "American College of Financial Services",
    "identity": "American College of Financial Services",
    "spiderable": "all",
    "image": "/assets/themes/badges.theamericancollege.edu/images/seo_image.png",
    "twitterSite": "TheAmerCol",
    "twitterCreator": "TheAmerCol",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.theamericancollege.edu"],
    "spotlightUrl": null
  },
  "credentials.britishcouncil.org": {
    "title": "British Council",
    "description": "The British Council is the United Kingdom’s international organisation for cultural relations and educational opportunities.",
    "identity": "British Council",
    "languages": ["en-gb"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@BritishCouncil",
    "twitterCreator": "@BritishCouncil",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.britishcouncil.org"],
    "spotlightUrl": null
  },
  "badges.spglobal.com": {
    "title": "Badges S&P Global",
    "description": "We accelerate progress through our essential intelligence, providing data & analytics, research & commentary, credit ratings, benchmarks and ESG solutions.",
    "identity": "Badges S&P Global",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@SPGlobal",
    "twitterCreator": "@SPGlobal",
    "app": "recipient-portal",
    "recipientPortalUrls": ["badges.spglobal.com"],
    "spotlightUrl": null
  },
  "badges.slackcertified.com": {
    "title": "Slack Certified",
    "description": "Discover new, interactive ways to grow your Slack career skills and prove your knowledge to the world.",
    "identity": "Slack Certified",
    "languages": ["en", "ja", "de"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@SlackHQ",
    "twitterCreator": "@SlackHQ",
    "app": "recipient-portal",
    "recipientPortalUrls": ["badges.slackcertified.com"],
    "spotlightUrl": "directory.slackcertified.com"
  },
  "certificates.ami.org.au": {
    "title": "Australian Marketing Institute",
    "description": "Australian Marketing Institute (AMI) is the professional association for marketers in Australia. AMI membership supports marketers at every stage of their marketing career through training, professional development and a collaborative network of professional marketers from across Australia.",
    "identity": "Australian Marketing Institute",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/certificates.ami.org.au/images/seo_image.png",
    "twitterSite": "@AMI_Marketing_",
    "twitterCreator": "@AMI_Marketing_",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certificates.ami.org.au"],
    "spotlightUrl": null,
    "samlSsoUrl": ""
  },
  "credentials.freejoo.com": {
    "title": "Freejoo",
    "description": "THE Global Community of Educators",
    "identity": "freejoo",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentials.freejoo.com/images/seo_image.png",
    "twitterSite": "@freejoo1",
    "twitterCreator": "@freejoo1",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.freejoo.com"],
    "spotlightUrl": "directory.freejoo.com"
  },
  "google.cloud.credential.net": {
    "title": "Google Cloud Certifications",
    "description": "Google Cloud certifications validate your expertise and showcase your ability to transform businesses with Google Cloud technology.",
    "identity": "Google Cloud Certifications",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/google.cloud.credential.net/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "recipientPortalUrls": ["google.cloud.credential.net"],
    "spotlightUrl": "googlecloudcertified.credential.net"
  },
  "kwm.legaltechbelts.com": {
    "title": "King & Wood Mallesons - the global elite firm for the next century",
    "description": "As a leading international law firm headquartered in Asia, we help clients to open doors and unlock opportunities as they look to Asian markets to unleash their full potential. Combining an unrivalled depth of expertise and breadth of relationships in our core markets, we are connecting Asia to the world, and the world to Asia.",
    "identity": "King & Wood Mallesons",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@kwmlaw",
    "twitterCreator": "@kwmlaw",
    "app": "recipient-portal",
    "recipientPortalUrls": ["kwm.legaltechbelts.com"],
    "spotlightUrl": null
  },
  "certificates.simnetonline.com": {
    "title": "McGraw-Hill - SIMnet keep I.T. simple!",
    "description": "SIMnet is an online training and assessment solution for Microsoft Office. Providing students with life-long access and unlimited practice on Microsoft Word, Excel, Access, PowerPoint and more.",
    "identity": "McGraw-Hill - SIMnet",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/certificates.simnetonline.com/images/seo_image.png",
    "twitterSite": "@mhhighered",
    "twitterCreator": "@mhhighered",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certificates.simnetonline.com"],
    "spotlightUrl": null
  },
  "certificates.nsca.com": {
    "title": "NSCA - National Strength and Conditioning Association",
    "description": "National Strength and Conditioning Association",
    "identity": "NSCA",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@NSCA",
    "twitterCreator": "@NSCA",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certificates.nsca.com"],
    "spotlightUrl": "directory.nsca.com"
  },
  "verify.ukas.com": {
    "title": "UKAS - The UK Accreditation Body - Creating Confidence - UKAS",
    "description": "The United Kingdom Accreditation Service (UKAS) Assess And Accredit Organisations That Provide Certification, Testing, Inspection & Calibration Services.",
    "identity": "UKAS",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/verify.ukas.com/images/seo_image.png",
    "twitterSite": "@UKAS",
    "twitterCreator": "@UKAS",
    "app": "recipient-portal",
    "recipientPortalUrls": ["verify.ukas.com"],
    "spotlightUrl": null
  },
  "www.proficientcredentials.com": {
    "title": "Proficient Credentials - CareerNet",
    "description": "Proficient - Careers, Jobs, Training, Assessments, Better, Brighter Futures",
    "identity": "Proficient Credentials",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@careerNet5",
    "twitterCreator": "@careerNet5",
    "app": "recipient-portal",
    "recipientPortalUrls": ["www.proficientcredentials.com"],
    "spotlightUrl": null
  },
  "opencreds.openlearning.com": {
    "title": "OpenLearning: Teach and learn online today",
    "description": "OpenLearning is a social online learning and MOOC platform that allows universities, colleges and educators to create, design, deliver, market online and blended courses.",
    "identity": "OpenLearning",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@openlrning",
    "twitterCreator": "@openlrning",
    "app": "recipient-portal",
    "recipientPortalUrls": ["opencreds.openlearning.com"],
    "spotlightUrl": null
  },
  "credentials.databricks.com": {
    "title": "Databricks",
    "description": "All your data, analytics and AI on one Lakehouse platform",
    "identity": "Databricks",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@databricks",
    "twitterCreator": "@databricks",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.databricks.com"],
    "spotlightUrl": null
  },
  "credentials.corporatefinanceinstitute.com": {
    "title": "Corporate Finance Institute",
    "description": "Financial modeling courses. Get CFI's financial analyst training in corporate finance, valuation, Excel, accounting, FMVA financial modeling certification.",
    "identity": "Corporate Finance Institute",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentials.corporatefinanceinstitute.com/images/seo_image.png",
    "twitterSite": "@cfi_education",
    "twitterCreator": "@cfi_education",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.corporatefinanceinstitute.com"],
    "spotlightUrl": "directory.corporatefinance.org"
  },
  "credential.advanceonline.cam.ac.uk": {
    "title": "Cambridge University Press",
    "description": "Cambridge Advance Online is a new programme of online short courses from the University of Cambridge. Our aim is to deliver premium online learning experiences for professionals who want to advance their careers, connect with a network of peer learners, and gain insight from leaders in the field.",
    "identity": "Cambridge University Press",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@camunionline",
    "twitterCreator": "@camunionline",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credential.advanceonline.cam.ac.uk"],
    "spotlightUrl": null
  },
  "employment.accredible.com": {
    "title": "ACME Professional Directory",
    "description": "The Association for Computing and Mathematical Excellence is dedicated to promoting and recognising achievement in the field of computing and computational science.",
    "identity": "Association for Computing and Mathematical Excellence",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": ["credential.accredible.com"],
    "spotlightUrl": "employment.accredible.com"
  },
  "directory.nsca.com": {
    "title": "NSCA Certified Professional Directory",
    "description": "Premier Directory of NSCA Certified Professionals",
    "identity": "National Strength and Conditioning Association [spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@NSCA",
    "twitterCreator": "@NSCA",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.nsca.com"
  },
  "aonhrlearningcenter.directory.aon.com": {
    "title": "Aon HR Learning Center",
    "description": "Empowering HR for Business Impact with",
    "identity": "Aon HR Learning Center [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/aonhrlearningcenter.directory.aon.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": ["aonhrlearningcenter.credentials.aon.com"],
    "spotlightUrl": "aonhrlearningcenter.directory.aon.com"
  },
  "directory.slackcertified.com": {
    "title": "Slack Certified Directory",
    "description": "Directory of slack certified Professionals",
    "identity": "Slack [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": ["badges.slackcertified.com"],
    "spotlightUrl": "directory.slackcertified.com"
  },
  "credentialdirectory.sage.com": {
    "title": "Sage Digital Badges Directory",
    "description": "Directory of Sage certified professionals",
    "identity": "Sage [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentialdirectory.sage.com/images/seo_image.png",
    "twitterSite": "@sagegroupplc",
    "twitterCreator": "@sagegroupplc",
    "app": "spotlight",
    "recipientPortalUrls": ["credentials.sage.com"],
    "spotlightUrl": "credentialdirectory.sage.com"
  },
  "directory.freejoo.com": {
    "title": "Freejoo",
    "description": "The Global Community of Educators",
    "identity": "Freejoo [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/directory.freejoo.com/images/seo_image.png",
    "twitterSite": "@freejoo1",
    "twitterCreator": "@freejoo1",
    "app": "spotlight",
    "recipientPortalUrls": ["credentials.freejoo.com"],
    "spotlightUrl": "directory.freejoo.com"
  },
  "directory.corporatefinance.org": {
    "title": "Corporate Finance Institute",
    "description": "Financial modeling courses. Get CFI's financial analyst training in corporate finance, valuation, Excel, accounting, FMVA financial modeling certification.",
    "identity": "Corporate Finance Institute (CFI) [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@cfi_education",
    "twitterCreator": "@cfi_education",
    "app": "spotlight",
    "recipientPortalUrls": ["credentials.corporatefinanceinstitute.com"],
    "spotlightUrl": "directory.corporatefinance.org"
  },
  "googlecloudcertified.credential.net": {
    "title": "Google Cloud Certifications",
    "description": "Google Cloud certifications validate your expertise and showcase your ability to transform businesses with Google Cloud technology.",
    "identity": "Google Cloud [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": ["google.cloud.credential.net"],
    "spotlightUrl": "googlecloudcertified.credential.net"
  },
  "directory.firestop.org": {
    "title": "International Firestop Council",
    "description": "The IFC's mission is to promote the technology of fire and smoke containment in building construction through research, education, development of safety standards, testing, and code provision.",
    "identity": "International Firestop Council [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/directory.firestop.org/images/seo_image.png",
    "twitterSite": "@Firestop_Org",
    "twitterCreator": "@Firestop_Org",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.firestop.org"
  },
  "registry.ppdm.org": {
    "title": "PPDM Association",
    "description": "The Professional Petroleum Data Management (PPDM) Association is the global, not-for-profit society within the petroleum industry that provides leadership for the professionalization of petroleum data management through the development and dissemination of best practices and standards, education programs, certification programs and professional development opportunities. PPDM represents and supports the needs of operating companies, regulators, software vendors, data vendors, consulting companies and data management professionals around the globe.",
    "identity": "PPDM Association",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@PPDMAssociation",
    "twitterCreator": "@PPDMAssociation",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "registry.ppdm.org"
  },
  "accredible.adskills.com": {
    "title": "Master All Types of Online Advertising Methods",
    "description": "All of our courses are backed by millions of dollars in real life campaign testing and updated monthly for the freshest most reliable training on the market.",
    "identity": "AdSkills [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "accredible.adskills.com"
  },
  "directory.centralreach.com": {
    "title": "CR Institute Certified Professional Directory",
    "description": "Premier Directory of CentralReach Certified Professionals",
    "identity": "CR Institute Certified [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/directory.centralreach.com/images/seo_image.png",
    "twitterSite": "@centralreach",
    "twitterCreator": "@centralreach",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.centralreach.com"
  },
  "directory.productschool.com": {
    "title": "Product School Certified Certified Product Managers",
    "description": "Product School Certified Alumni Directory",
    "identity": "Product School [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@productschool",
    "twitterCreator": "@productschool",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.productschool.com"
  },
  "spotlight.rsmus.com": {
    "title": "RSM - audit, tax, consulting services for the middle market",
    "description": "RSM US LLP is the leading U.S. provider of audit, tax and consulting services focused on the middle market.",
    "identity": "RSM LLC [Spotlight]",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/spotlight.rsmus.com/images/seo_image.gif",
    "twitterSite": "@RSMUSLLP",
    "twitterCreator": "@RSMUSLLP",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "spotlight.rsmus.com"
  },
  "directory.intercom.com": {
    "title": "Intercom Academy Directory",
    "description": "Build better customer relationships through conversational, messenger-based experiences with Intercom.",
    "identity": "Intercom",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/directory.intercom.com/images/seo_image.png",
    "twitterSite": "@Intercomacademy",
    "twitterCreator": "@Intercomacademy",
    "app": "spotlight",
    "recipientPortalUrls": ["credentials.intercom.com"],
    "spotlightUrl": "directory.intercom.com"
  },
  "certification.healthacademy.io": {
    "title": "Health Academy",
    "description": "Improve your skillset, grow your business, and unleash your potential - today!",
    "identity": "Health Academy",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@HealthAcademyEd",
    "twitterCreator": "@HealthAcademyEd",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certification.healthacademy.io"],
    "spotlightUrl": null
  },
  "certs.digitalmarketinginstitute.com": {
    "title": "Digital Marketing Institute",
    "description": "Gain an internationally recognised digital marketing certification with DMI. Study online or in a classroom through one of our education partners. Enroll Now.",
    "identity": "Digital Marketing Institute",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/certs.digitalmarketinginstitute.com/images/seo_image.png",
    "twitterSite": "@dmigroup",
    "twitterCreator": "@dmigroup",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certs.digitalmarketinginstitute.com"],
    "spotlightUrl": null
  },
  "credentials.englishonline.britishcouncil.org": {
    "title": "Learn English Online - British Council",
    "description": "Are you learning English? The British Council has thousands of high-quality resources to help you improve your English and help your children Learn English.",
    "identity": "Learn English Online - British Council",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@LearnEnglish_BC",
    "twitterCreator": "@English_BC",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.englishonline.britishcouncil.org"],
    "spotlightUrl": null
  },
  "credentials.kfshrc.edu.sa": {
    "title": "King Faisal Specialist Hospital and Research Centre",
    "description": "King Faisal Specialist Hospital and Research Centre",
    "identity": "KFSHRC",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentials.kfshrc.edu.sa/images/seo_image.png",
    "twitterSite": "@KFSHRC",
    "twitterCreator": "@KFSHRC",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.kfshrc.edu.sa"],
    "spotlightUrl": null
  },
  "directory.afememberservices.net": {
    "title": "Association for Facilities Engineering",
    "description": "Each day we work to advance our mission to provide tools and resources to enhance the expertise and broaden the connections of facility management professionals worldwide.",
    "identity": " Association for Facilities Engineering",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/directory.afememberservices.net/images/seo_image.png",
    "twitterSite": "@FacilitiesEng",
    "twitterCreator": "@FacilitiesEng",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.afememberservices.net"
  },
  "membershipbadge.ampp.org": {
    "title": "AMPP - The Association for Materials Protection and Performance",
    "description": "AMPP is the destination for collaboratively developed consensus standards that establish best practices on surface prep, protective coatings application, quality assurance, and corrosion prevention and control.",
    "identity": "AMPP - The Association for Materials Protection and Performance",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/membershipbadge.ampp.org/images/seo_image.jpeg",
    "twitterSite": "@AmppOrg",
    "twitterCreator": "@AmppOrg",
    "app": "recipient-portal",
    "recipientPortalUrls": ["membershipbadge.ampp.org"],
    "spotlightUrl": null
  },
  "mad-certified.mitre-engenuity.org": {
    "title": "Mitre Engenuity",
    "description": "MITRE Engenuity carries the MITRE Corporation's heritage of trust, objectivity and groundbreaking systems engineering. We are an independent organization, but we uphold MITRE's mission of a safer world and commitment to the greater good.",
    "identity": "Mitre Engenuity",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/mad-certified.mitre-engenuity.org/images/seo_image.png",
    "twitterSite": "@MITREengenuity",
    "twitterCreator": "@MITREengenuity",
    "app": "recipient-portal",
    "recipientPortalUrls": ["mad-certified.mitre-engenuity.org"],
    "spotlightUrl": null
  },
  "blockchain.stem.org": {
    "title": "STEM.org - Educational Research & Credentialing Est. 2001",
    "description": "STEM.org",
    "identity": "STEM.org",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@stemdotorg",
    "twitterCreator": "@stemdotorg",
    "app": "recipient-portal",
    "recipientPortalUrls": ["blockchain.stem.org"],
    "spotlightUrl": "directory.stem.org"
  },
  "directory.fminstitute.com": {
    "title": "The Financial Modeling Institute's Credential Holder Directory",
    "description": "The Financial Modeling Institute's Credential Holder Directory",
    "identity": "The Financial Modeling Institute",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@FMI_Institute",
    "twitterCreator": "@FMI_Institute",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.fminstitute.com"
  },
  "credentials.elastic.co": {
    "title": "Elastic Certified Professional Directory",
    "description": "Elastic Certified Professional Directory",
    "identity": "Elastic",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentials.elastic.co/images/seo_image.png",
    "twitterSite": "@elastic",
    "twitterCreator": "@elastic",
    "app": "spotlight",
    "recipientPortalUrls": [],
    "spotlightUrl": "credentials.elastic.co"
  },
  "credentials.ampp.org": {
    "title": "AMPP Credentials",
    "description": "AMPP is a global community of professionals dedicated to materials protection through the advancement of corrosion control and protective coatings.",
    "identity": "AMPP",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credentials.ampp.org/images/seo_image.jpeg",
    "twitterSite": "@AmppOrg",
    "twitterCreator": "@AmppOrg",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.ampp.org"],
    "spotlightUrl": null
  },
  "certificates.iseb.co.uk": {
    "title": "ISEB",
    "description": "The Independent Schools Examinations Board provides examinations and assessments for pupils seeking entry to independent senior schools at 11+ and 13+. These include the Common Pre-Tests, Common Entrance and Common Academic Scholarship examinations.",
    "identity": "Independent Schools Examination Board",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@ISEBexams",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certificates.iseb.co.uk"],
    "spotlightUrl": null
  },
  "academy-achievements.gong.io": {
    "title": "Gong Academy",
    "description": "Gong Academy",
    "identity": "Gong Academy",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@Gong_io",
    "twitterCreator": "@Gong_io",
    "app": "recipient-portal",
    "recipientPortalUrls": ["academy-achievements.gong.io"],
    "spotlightUrl": "academy-certified.gong.io"
  },
  "certificates.coursesindoha.com": {
    "title": "coursesindoha",
    "description": "Join & learn top creative courses and workshops from expert professionals in Qatar. Coursesindoha is the largest and fastest growing, lifelong learners' community in the region.",
    "identity": "coursesindoha",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/certificates.coursesindoha.com/images/seo_image.svg",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certificates.coursesindoha.com"],
    "spotlightUrl": null
  },
  "stripecertifications.credential.net": {
    "title": "Stripe Certifications",
    "description": "Stripe Certifications",
    "identity": "Stripe Certifications",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/stripecertifications.credential.net/images/seo_image.png",
    "twitterSite": "@stripe",
    "twitterCreator": "@stripe",
    "app": "recipient-portal",
    "recipientPortalUrls": ["stripecertifications.credential.net"],
    "spotlightUrl": "stripe.credential.net"
  },
  "stripe.credential.net": {
    "title": "Stripe Certifications Credential Holder Directory",
    "description": "Stripe Certifications Credential Holder Directory",
    "identity": "Stripe Certifications Credential Holder Directory",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/stripe.credential.net/images/seo_image.png",
    "twitterSite": "@stripe",
    "twitterCreator": "@stripe",
    "app": "spotlight",
    "recipientPortalUrls": ["stripecertifications.credential.net"],
    "spotlightUrl": "stripe.credential.net"
  },
  "academy-certified.gong.io": {
    "title": "Gong Academy",
    "description": "Gong Academy",
    "identity": "Gong Academy",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@Gong_io",
    "twitterCreator": "@Gong_io",
    "app": "spotlight",
    "recipientPortalUrls": ["academy-achievements.gong.io"],
    "spotlightUrl": "academy-certified.gong.io"
  },
  "directory.stem.org": {
    "title": "STEM.org Credential Holder Directory",
    "description": "STEM.org Credential Holder Directory",
    "identity": "STEM.org Credential Holder Directory",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@stemdotorg",
    "twitterCreator": "@stemdotorg",
    "app": "spotlight",
    "recipientPortalUrls": ["blockchain.stem.org"],
    "spotlightUrl": "directory.stem.org"
  },
  "directory.accdirectors.com": {
    "title": "The Director Database",
    "description": "A public database of Board of Director candidates certified by the American College of Corporate Directors, a credentialing organization dedicated to providing the gold standard in public company director education.",
    "identity": "The Director Database - Spotlight (365Media)",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/directory.accdirectors.com/images/seo_image.png",
    "twitterSite": "@CorpBoardMember",
    "twitterCreator": "@CorpBoardMember",
    "app": "spotlight",
    "recipientPortalUrls": ["credential.net"],
    "spotlightUrl": "directory.accdirectors.com"
  },
  "acme-spotlight.accredible.com": {
    "title": "ACME",
    "description": "The Association for Computing and Mathematical Excellence is dedicated to promoting and recognising achievement in the field of computing and computational science.",
    "identity": "Association for Computing and Mathematical Excellence",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": ["credential.net"],
    "spotlightUrl": "acme-spotlight.accredible.com"
  },
  "credential.prmia.org": {
    "title": "PRMIA",
    "description": "PRMIA is a member based association. Our mission is to provide an open forum for the development and promotion of the risk profession.",
    "identity": "PRMIA",
    "languages": ["en"],
    "spiderable": "all",
    "image": "/assets/themes/credential.prmia.org/images/seo_image.png",
    "twitterSite": "https://twitter.com/PRMIA",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "recipientPortalUrls": ["credential.net"],
    "spotlightUrl": "credential.prmia.org"
  },
  "credentials.sage.com": {
    "title": "Sage University",
    "description": "Sage is the market leader for integrated accounting, payroll, and payment systems, supporting the ambition of the world’s entrepreneurs.",
    "identity": "Sage University",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@sagegroupplc",
    "twitterCreator": "@sagegroupplc",
    "app": "recipient-portal",
    "languages": ["en", "en-gb", "de", "es", "fr"],
    "recipientPortalUrls": ["credentials.sage.com"],
    "spotlightUrl": "credentialdirectory.sage.com"
  },
  "directory.iiba.org": {
    "title": "IIBA Directory",
    "description": "International Institute of Business Analysis™ (IIBA®) is a professional association dedicated to supporting business analysis professionals deliver better business outcomes. IIBA connects almost 30,000 members, over 100 Chapters, and more than 500 training, academic, and corporate partners around the world. As the global voice of the business analysis community, IIBA supports recognition of the profession, networking and community engagement, standards and resource development, and comprehensive certification programs. For more information visit iiba.org. ",
    "identity": "IIBA Directory",
    "languages": ["en"],
    "spiderable": "all",
    "image": "",
    "twitterSite": "@IIBA",
    "twitterCreator": "@IIBA",
    "app": "spotlight",
    "recipientPortalUrls": ["badges.iiba.org"],
    "spotlightUrl": "directory.iiba.org"
  },
  "badges.iiba.org": {
    "title": "International Institute of Business Analysis™ | IIBA®",
    "description": "International Institute of Business Analysis™ (IIBA®) is a professional association dedicated to supporting business analysis professionals deliver better business outcomes. IIBA connects almost 30,000 members, over 100 Chapters, and more than 500 training, academic, and corporate partners around the world. As the global voice of the business analysis community, IIBA supports recognition of the profession, networking and community engagement, standards and resource development, and comprehensive certification programs. For more information visit iiba.org.",
    "identity": "IIBA",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@IIBA",
    "twitterCreator": "@IIBA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.iiba.org"],
    "spotlightUrl": "directory.iiba.org"
  },
  "certification.web3.wharton.upenn.edu": {
    "title": "Wharton Executive Education",
    "description": "Economics of Blockchain and Digital Assets",
    "identity": "Wharton Executive Education",
    "spiderable": "all",
    "image": "/assets/themes/certification.web3.wharton.upenn.edu/images/seo_image.png",
    "twitterSite": "@Wharton",
    "twitterCreator": "@Wharton",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certification.web3.wharton.upenn.edu"],
    "spotlightUrl": null
  },
  "certificates.crossfit.com": {
    "title": "Crossfit LLC",
    "description": "Crossfit LLC",
    "identity": "Crossfit LLC",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@CrossFitCourses",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.crossfit.com"],
    "spotlightUrl": null
  },
  "digitalexhibit.efcollegestudytours.com": {
    "title": "Education First",
    "description": "Opening the world through education. EF helps begin a lifelong journey of global citizenship. Learn more about who we are and what we do.",
    "identity": "Education First",
    "spiderable": "all",
    "image": "/assets/themes/digitalexhibit.efcollegestudytours.com/images/seo_image.png",
    "twitterSite": "@EFCollegeStudy",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "digitalexhibit.efcollegestudytours.com"
  },
  "credentials.trimble.com": {
    "title": "Trimble Credential Holder Directory",
    "description": "Trimble Credential Holder Directory",
    "identity": "Trimble",
    "spiderable": "all",
    "image": "/assets/themes/credentials.trimble.com/images/seo_image.png",
    "twitterSite": "@TrimbleCorpNews",
    "twitterCreator": "@TrimbleCorpNews",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "credentials.trimble.com"
  },
  "google.sandbox.employment.accredible.com": {
    "title": "Google Mastery",
    "description": "Google Mastery Credential Directory",
    "identity": "Google Mastery",
    "spiderable": "all",
    "image": "/assets/themes/google.sandbox.employment.accredible.com/images/seo_image.png",
    "twitterSite": "@Google",
    "twitterCreator": "@Google",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "google.sandbox.employment.accredible.com"
  },
  "badges.nhsa.org": {
    "title": "National Head Start Association",
    "description": "The National Head Start Association's mission is to coalesce, inspire, and support the Head Start field as a leader in early childhood development and education.",
    "identity": "National Head Start Association",
    "spiderable": "all",
    "image": "/assets/themes/badges.nhsa.org/images/seo_image.png",
    "twitterSite": "@NatlHeadStart",
    "twitterCreator": "@NatlHeadStart",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.nhsa.org"],
    "spotlightUrl": null
  },
  "kwm.legaltransformationbelts.com": {
    "title": "King & Wood Mallesons",
    "description": "King & Wood Mallesons (Transformation Belts)",
    "identity": "King & Wood Mallesons",
    "spiderable": "all",
    "image": "",
    "twitterSite": "kwmlaw",
    "twitterCreator": "kwmlaw",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["kwm.legaltransformationbelts.com"],
    "spotlightUrl": null
  },
  "directory.mountaingoatsoftware.com": {
    "title": "Mountain Goat Software",
    "description": "For over twenty years I've been building high-performing software development teams and organizations through the use of agile and Scrum. I've worked with startups and some of the largest organizations in the world.  My in-person training, coaching, and online video courses work together to give you everything you need to deliver the right product on time every time.",
    "identity": "Mountain Goat Software",
    "spiderable": "all",
    "image": "/assets/themes/directory.mountaingoatsoftware.com/images/seo_image.jpeg",
    "twitterSite": "@mikewcohn",
    "twitterCreator": "@mikewcohn",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["directory.mountaingoatsoftware.com"],
    "spotlightUrl": null
  },
  "credentials.charteredbankerinstitute.com": {
    "title": "Chartered Banker Institute Credentials",
    "description": "Chartered Banker Institute Credentials",
    "identity": "Chartered Banker Institute Credentials",
    "spiderable": "all",
    "image": "/assets/themes/credentials.charteredbankerinstitute.com/images/seo_image.jpg",
    "twitterSite": "@charteredbanker",
    "twitterCreator": "@charteredbanker",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.charteredbankerinstitute.com"],
    "spotlightUrl": null
  },
  "abemcertified.abem.org": {
    "title": "ABEM Certifications Spotlight Directory",
    "description": "ABEM Certifications Spotlight Directory",
    "identity": "ABEM Certifications",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@ABEMCert",
    "twitterCreator": "ABEMCert",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcerts.abem.org"],
    "spotlightUrl": "abemcertified.abem.org"
  },
  "digitalcerts.abem.org": {
    "title": "ABEM Certifications",
    "description": "ABEM Certifications",
    "identity": "ABEM Certifications",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@ABEMCert",
    "twitterCreator": "ABEMCert",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcerts.abem.org"],
    "spotlightUrl": "abemcertified.abem.org"
  },
  "credentials.workato.com": {
    "title": "Workato",
    "description": "Give yourself the strongest foundation to automate your work using this series of Workato certificated self-paced courses. Earn a certificate for each course level to mark your progress.",
    "identity": "Workato",
    "spiderable": "all",
    "image": "/assets/themes/credentials.workato.com/images/seo_image.png",
    "twitterSite": "@Workato",
    "twitterCreator": "@Workato",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.workato.com"],
    "spotlightUrl": null
  },
  "credentials.prb-academy.com": {
    "title": "Chartered Banker Institute Credentials",
    "description": "Chartered Banker Institute Credentials",
    "identity": "Chartered Banker Institute Credentials",
    "spiderable": "all",
    "image": "/assets/themes/credentials.prb-academy.com/images/seo_image.jpg",
    "twitterSite": "@charteredbanker",
    "twitterCreator": "@charteredbanker",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.prb-academy.com"],
    "spotlightUrl": null
  },
  "certificates.shiseidoplus.com": {
    "title": "Shiseido Co., Ltd",
    "description": "Shiseido Co., Ltd",
    "identity": "Shiseido Co., Ltd",
    "spiderable": "all",
    "image": "/assets/themes/certificates.shiseidoplus.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.shiseidoplus.com"],
    "spotlightUrl": null
  },
  "directory.nhsa.org": {
    "title": "National Head Start Association",
    "description": "The National Head Start Association's mission is to coalesce, inspire, and support the Head Start field as a leader in early childhood development and education.",
    "identity": "National Head Start Association",
    "spiderable": "all",
    "image": "/assets/themes/directory.nhsa.org/images/seo_image.png",
    "twitterSite": "@NatlHeadStart",
    "twitterCreator": "@NatlHeadStart",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.nhsa.org"
  },
  "certificates.isoc.org": {
    "title": "Internet Society",
    "description": "Build, Promote and Defend the Internet - Internet Society",
    "identity": "Internet Society",
    "spiderable": "all",
    "image": "/assets/themes/certificates.isoc.org/images/seo_image.png",
    "twitterSite": "@internetsociety",
    "twitterCreator": "@internetsociety",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.isoc.org"],
    "spotlightUrl": "directory.isoc.org"
  },
  "directory.isoc.org": {
    "title": "Internet Society",
    "description": "Build, Promote and Defend the Internet - Internet Socity",
    "identity": "Internet Society",
    "spiderable": "all",
    "image": "/assets/themes/directory.isoc.org/images/seo_image.png",
    "twitterSite": "@internetsociety",
    "twitterCreator": "@internetsociety",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.isoc.org"],
    "spotlightUrl": "directory.isoc.org"
  },
  "isqi.skillsclub.com": {
    "title": "iSQI",
    "description": "iSQI",
    "identity": "iSQI",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["isqi.skillsclub.com"],
    "spotlightUrl": null
  },
  "skillshop.accredible.com": {
    "title": "Google Mastery",
    "description": "Google Mastery Credential Directory",
    "identity": "Google Mastery",
    "spiderable": "all",
    "image": "/assets/themes/skillshop.accredible.com/images/seo_image.png",
    "twitterSite": "@Google",
    "twitterCreator": "@Google",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "skillshop.accredible.com"
  },
  "gasq.skillsclub.com": {
    "title": "GASQ",
    "description": "GASQ",
    "identity": "GASQ",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["gasq.skillsclub.com"],
    "spotlightUrl": null
  },
  "certificates.nhsa.org": {
    "title": "National Head Start Association",
    "description": "The National Head Start Association's mission is to coalesce, inspire, and support the Head Start field as a leader in early childhood development and education.",
    "identity": "National Head Start Association",
    "spiderable": "all",
    "image": "/assets/themes/certificates.nhsa.org/images/seo_image.png",
    "twitterSite": "@NatlHeadStart",
    "twitterCreator": "@NatlHeadStart",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.nhsa.org"],
    "spotlightUrl": null
  },
  "certificates.trinitycollege.com": {
    "title": "Trinity College London",
    "description": "Transforming lives through the power of communication and performance",
    "identity": "Trinity College London",
    "spiderable": "all",
    "image": "/assets/themes/certificates.trinitycollege.com/images/seo_image.svg",
    "twitterSite": "@TrinityC_L",
    "twitterCreator": "@TrinityC_L",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.trinitycollege.com"],
    "spotlightUrl": null
  },
  "skillshop.credential.net": {
    "title": "Google Mastery",
    "description": "Google Mastery Credential Directory",
    "identity": "Google Mastery",
    "spiderable": "all",
    "image": "/assets/themes/skillshop.credential.net/images/seo_image.png",
    "twitterSite": "@Google",
    "twitterCreator": "@Google",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["skillshop.credential.net"],
    "spotlightUrl": null
  },
  "directory.workato.com": {
    "title": "Workato",
    "description": "Give yourself the strongest foundation to automate your work using this series of Workato certificated self-paced courses. Earn a certificate for each course level to mark your progress.",
    "identity": "Workato",
    "spiderable": "all",
    "image": "/assets/themes/directory.workato.com/images/seo_image.png",
    "twitterSite": "@Workato",
    "twitterCreator": "@Workato",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.workato.com"
  },
  "certificates.astho.org": {
    "title": "ASTHO",
    "description": "Supporting state and territorial health agencies to advance health equity and optimal health for all.",
    "identity": "ASSOCIATION OF STATE AND TERRITORIAL HEALTH OFFICIALS",
    "spiderable": "all",
    "image": "/assets/themes/certificates.astho.org/images/seo_image.png",
    "twitterSite": "@astho",
    "twitterCreator": "@astho",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.astho.org"],
    "spotlightUrl": "verify.astho.org"
  },
  "verify.astho.org": {
    "title": "ASTHO",
    "description": "Supporting state and territorial health agencies to advance health equity and optimal health for all.",
    "identity": "ASSOCIATION OF STATE AND TERRITORIAL HEALTH OFFICIALS",
    "spiderable": "all",
    "image": "/assets/themes/verify.astho.org/images/seo_image.png",
    "twitterSite": "@astho",
    "twitterCreator": "@astho",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.astho.org"],
    "spotlightUrl": "verify.astho.org"
  },
  "badgecert.metlife.com": {
    "title": "MetLife Credentials",
    "description": "MetLife Credentials",
    "identity": "MetLife",
    "spiderable": "all",
    "image": "/assets/themes/badgecert.metlife.com/images/seo_image.jpeg",
    "twitterSite": "@metlife",
    "twitterCreator": "@metlife",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badgecert.metlife.com"],
    "spotlightUrl": null
  },
  "credentials.uipath.com": {
    "title": "UiPath Digital Credentials",
    "description": "UiPath Digital Credentials",
    "identity": "UiPath Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/credentials.uipath.com/images/seo_image.png",
    "twitterSite": "@UiPath",
    "twitterCreator": "@UiPath",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.uipath.com"],
    "spotlightUrl": "credentialsdirectory.uipath.com",
    "samlSsoUrl": ""
  },
  "credentialsdirectory.uipath.com": {
    "title": "UiPath Credential Holder Directory",
    "description": "UiPath Credential Holder Directory",
    "identity": "UiPath Credential Holder Directory",
    "spiderable": "all",
    "image": "/assets/themes/credentialsdirectory.uipath.com/images/seo_image.png",
    "twitterSite": "@UiPath",
    "twitterCreator": "@UiPath",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.uipath.com"],
    "spotlightUrl": "credentialsdirectory.uipath.com",
    "samlSsoUrl": ""
  },
  "directory.databrickscertified.com": {
    "title": "Databricks Certified Credential Holder Directory",
    "description": "Databricks Certified Credential Holder Directory",
    "identity": "Databricks Certified Credential Holder Directory",
    "spiderable": "all",
    "image": "/assets/themes/directory.databrickscertified.com/images/seo_image.svg",
    "twitterSite": "@databricks",
    "twitterCreator": "@databricks",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.databricks.com"],
    "spotlightUrl": "directory.databrickscertified.com"
  },
  "www.bairdachievements.com": {
    "title": "Discover the Difference | Baird",
    "description": "Baird is an employee-owned wealth management, capital markets, asset management and private equity firm. Leveraging our deep expertise and broad skills, we're dedicated to providing the best advice and service to our individual, corporate, institutional and municipal clients.",
    "identity": "Discover the Difference | Baird",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["www.bairdachievements.com"],
    "spotlightUrl": null
  },
  "directory.quada.org": {
    "title": "QUAD A Credential Directory",
    "description": "QUAD A Credential Directory",
    "identity": "QUAD A Credential Directory",
    "spiderable": "all",
    "image": "/assets/themes/directory.quada.org/images/seo_image.png",
    "twitterSite": "@QuadANow",
    "twitterCreator": "@QuadANow",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.quada.org"
  },
  "employment.certitrek.com": {
    "title": "CERTITREK - Professional Training and Certification",
    "description": "Certitrek Group is a workforce training organization on a mission to promote educational equality and facilitate professional development",
    "identity": "Certitrek",
    "spiderable": "all",
    "image": "/assets/themes/employment.certitrek.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "employment.certitrek.com"
  },
  "credentials.micron.com": {
    "title": "Micron Credentials",
    "description": "Micron Credentials",
    "identity": "Micron",
    "spiderable": "all",
    "image": "/assets/themes/credentials.micron.com/images/seo_image.avif",
    "twitterSite": "@MicronTech",
    "twitterCreator": "@MicronTech",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.micron.com"],
    "spotlightUrl": null
  },
  "certified.certitrek.com": {
    "title": "CERTITREK - Professional Training and Certification",
    "description": "Certitrek Group is a workforce training organization on a mission to promote educational equality and facilitate professional development",
    "identity": "Certitrek",
    "spiderable": "all",
    "image": "/assets/themes/certified.certitrek.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certified.certitrek.com"],
    "spotlightUrl": null
  },
  "certificates.orygen.org.au": {
    "title": "Orygen, Revolution in Mind - Digital Credentials",
    "description": "Orygen, Revolution in Mind - Digital Credentials",
    "identity": "Orygen, Revolution in Mind - Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/certificates.orygen.org.au/images/seo_image.jpeg",
    "twitterSite": "@orygen_aus",
    "twitterCreator": "@orygen_aus",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.orygen.org.au"],
    "spotlightUrl": null
  },
  "credentials.digitalskillsauthority.org": {
    "title": "Digital Skills Authority",
    "description": "Industry's Global Digital Skills Authority is digital skills awarding body that delivers high-impacting industry-recognised qualifications in digital an digital business",
    "identity": "Digital Skills Authority",
    "spiderable": "all",
    "image": "/assets/themes/credentials.digitalskillsauthority.org/images/seo_image.webp",
    "twitterSite": "@digitalskillsauthority",
    "twitterCreator": "@digitalskillsauthority",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.digitalskillsauthority.org"],
    "spotlightUrl": "certified.digitalskillsauthority.org"
  },
  "certified.digitalskillsauthority.org": {
    "title": "Digital Skills Authority",
    "description": "Industry's Global Digital Skills Authority is digital skills awarding body that delivers high-impacting industry-recognised qualifications in digital an digital business",
    "identity": "Digital Skills Authority",
    "spiderable": "all",
    "image": "/assets/themes/certified.digitalskillsauthority.org/images/seo_image.webp",
    "twitterSite": "@digitalskillsauthority",
    "twitterCreator": "@digitalskillsauthority",
    "app": "spotlight",
    "languages": ["en"],
    "spotlightUrl": "certified.digitalskillsauthority.org",
    "recipientPortalUrls": ["credentials.digitalskillsauthority.org"]
  },
  "badges.westernsydney.edu.au": {
    "title": "Western Sydney University Credentials",
    "description": "Western Sydney University Credentials",
    "identity": "Western Sydney University Credentials",
    "spiderable": "all",
    "image": "/assets/themes/badges.westernsydney.edu.au/images/seo_image.jpeg",
    "twitterSite": "@westernsydneyu",
    "twitterCreator": "@westernsydneyu",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.westernsydney.edu.au"],
    "spotlightUrl": null
  },
  "mocred.dci.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dci.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dci.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.ded.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.ded.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.ded.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dese.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dese.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dese.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dhewd.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dhewd.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dhewd.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dhss.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dhss.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dhss.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.doc.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.doc.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.doc.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dolir.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dolir.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dolir.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dmh.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dmh.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dmh.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dnr.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dnr.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dnr.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dor.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dor.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dor.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dps.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dps.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dps.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.dss.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.dss.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.dss.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.mda.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.mda.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.mda.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.mong.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.mong.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "duplicateOf": "mocred.oa.mo.gov",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.mong.mo.gov"],
    "spotlightUrl": null
  },
  "mocred.oa.mo.gov": {
    "title": "MO Appreciation - State Team Member Recognition Program",
    "description": "MO Appreciation - State Team Member Recognition Program",
    "identity": "MO Appreciation - State Team Member Recognition Program",
    "spiderable": "all",
    "image": "/assets/themes/mocred.oa.mo.gov/images/seo_image.png",
    "twitterSite": "@MoGov",
    "twitterCreator": "@MoGov",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["mocred.oa.mo.gov"],
    "spotlightUrl": null
  },
  "credentials.rutgers.edu": {
    "title": "Rutgers University Digital Credentials",
    "description": "Rutgers University Digital Credentials",
    "identity": "Rutgers University Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/credentials.rutgers.edu/images/seo_image.png",
    "twitterSite": "@RutgersU",
    "twitterCreator": "@RutgersU",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "credentials.nasm.org": {
    "title": "National Academy of Sports Medicine Digital Credentials",
    "description": "National Academy of Sports Medicine Digital Credentials",
    "identity": "National Academy of Sports Medicine",
    "spiderable": "all",
    "image": "/assets/themes/credentials.nasm.org/images/seo_image.png",
    "twitterSite": "@nasm",
    "twitterCreator": "@nasm",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.nasm.org"],
    "spotlightUrl": null
  },
  "newbrunswick.credentials.rutgers.edu": {
    "title": "Rutgers University - New Brunswick",
    "description": "Rutgers University - New Brunswick",
    "identity": "Rutgers University - New Brunswick",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["newbrunswick.credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "newark.credentials.rutgers.edu": {
    "title": "Rutgers University - Newark",
    "description": "Rutgers University - Newark",
    "identity": "Rutgers University - Newark",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["newark.credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "camden.credentials.rutgers.edu": {
    "title": "Rutgers University - Camden",
    "description": "Rutgers University - Camden",
    "identity": "Rutgers University - Camden",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["camden.credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "docs.credentials.rutgers.edu": {
    "title": "Rutgers Division of Continuing Studies",
    "description": "Rutgers Division of Continuing Studies",
    "identity": "Rutgers Division of Continuing Studies",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["docs.credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "rbhs.credentials.rutgers.edu": {
    "title": "Rutgers Biomedical and Health Sciences",
    "description": "Rutgers Biomedical and Health Sciences",
    "identity": "Rutgers Biomedical and Health Sciences",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["rbhs.credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "libraries.credentials.rutgers.edu": {
    "title": "Rutgers University Libraries",
    "description": "Rutgers University Libraries",
    "identity": "Rutgers University Libraries",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["libraries.credentials.rutgers.edu"],
    "spotlightUrl": null
  },
  "certificates.themakergroup.com": {
    "title": "The Maker Group",
    "description": "The Maker Group",
    "identity": "The Maker Group",
    "spiderable": "all",
    "image": "/assets/themes/certificates.themakergroup.com/images/seo_image.png",
    "twitterSite": "@TheMakerGroup3",
    "twitterCreator": "@TheMakerGroup3",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.themakergroup.com"],
    "spotlightUrl": null
  },
  "credentials.cfainstitute.org": {
    "title": "CFA Institute",
    "description": "To lead the investment profession globally by promoting the highest standards of ethics, education, and professional excellence for the ultimate benefit of society.",
    "identity": "CFA Institute",
    "spiderable": "all",
    "image": "/assets/themes/credentials.cfainstitute.org/images/seo_image.png",
    "twitterSite": "@CFAinstitute",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.cfainstitute.org"],
    "spotlightUrl": null
  },
  "certificates.globalreporting.org": {
    "title": "Global Reporting Initiative",
    "description": "Global Reporting Initiative",
    "identity": "Global Reporting Initiative",
    "spiderable": "all",
    "image": "/assets/themes/certificates.globalreporting.org/images/seo_image.png",
    "twitterSite": "@GRI_Secretariat",
    "twitterCreator": "@GRI_Secretariat",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.globalreporting.org"],
    "spotlightUrl": null
  },
  "certified.openlearning.com": {
    "title": "OpenLearning Directory",
    "description": "OpenLearning Directory",
    "identity": "OpenLearning Directory",
    "spiderable": "all",
    "image": "/assets/themes/certified.openlearning.com/images/seo_image.svg",
    "twitterSite": "@openlrning",
    "twitterCreator": "@openlrning",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "certified.openlearning.com"
  },
  "directory.nasm.org": {
    "title": "National Academy of Sports Medicine Credential Holder Directory",
    "description": "National Academy of Sports Medicine Credential Holder Directory",
    "identity": "National Academy of Sports Medicine",
    "spiderable": "all",
    "image": "/assets/themes/directory.nasm.org/images/seo_image.png",
    "twitterSite": "@NASM",
    "twitterCreator": "@NASM",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.nasm.org"
  },
  "certify.gfps.com": {
    "title": "GFPS Global Academy",
    "description": "GFPS Global Academy",
    "identity": "GFPS Global Academy",
    "spiderable": "all",
    "image": "",
    "twitterSite": "https://twitter.com/georgfischer",
    "twitterCreator": "https://twitter.com/georgfischer",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certify.gfps.com"],
    "spotlightUrl": null
  },
  "credentialsdirectory.rutgers.edu": {
    "title": "Rutgers University Digital Credentials",
    "description": "Rutgers University Digital Credentials",
    "identity": "Rutgers University Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/credentialsdirectory.rutgers.edu/images/seo_image.png",
    "twitterSite": "@RutgersU",
    "twitterCreator": "@RutgersU",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "credentialsdirectory.rutgers.edu"
  },
  "talentnetwork.wharton.upenn.edu": {
    "title": "Wharton Executive Education",
    "description": "Wharton Executive Education",
    "identity": "Wharton Executive Education",
    "spiderable": "all",
    "image": "/assets/themes/talentnetwork.wharton.upenn.edu/images/seo_image.png",
    "twitterSite": "Wharton Executive Education",
    "twitterCreator": "Wharton Executive Education",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "talentnetwork.wharton.upenn.edu",
    "samlSsoUrl": ""
  },
  "google.accredible.com": {
    "title": "Google Cloud Certifications",
    "description": "Google Cloud Certifications",
    "identity": "Google Cloud Certifications",
    "spiderable": "all",
    "image": "/assets/themes/google.accredible.com/images/seo_image.svg",
    "twitterSite": "@GoogleCloudTech",
    "twitterCreator": "@GoogleCloudTech",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["google.accredible.com"],
    "spotlightUrl": null
  },
  "certificates.multiverse.io": {
    "title": "Multiverse",
    "description": "Multiverse",
    "identity": "Multiverse",
    "spiderable": "all",
    "image": "/assets/themes/certificates.multiverse.io/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.multiverse.io"],
    "spotlightUrl": null
  },
  "certifications.mitel.com": {
    "title": "Mitel Phone System & Contact Center Certifications & Badges | Accredible",
    "description": "See all available official Mitel digital certifications and badges you can earn and display to raise you status on Accredible. Verified by blockchain.",
    "identity": "Mitel",
    "spiderable": "all",
    "image": "/assets/themes/certifications.mitel.com/images/seo_image.png",
    "twitterSite": "https://twitter.com/Mitel",
    "twitterCreator": "https://twitter.com/Mitel",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.mitel.com"],
    "spotlightUrl": null
  },
  "badges.personio.com": {
    "title": "Personio",
    "description": "Personio Voyager Academy",
    "identity": "Personio",
    "spiderable": "all",
    "image": "/assets/themes/badges.personio.com/images/seo_image.png",
    "twitterSite": "https://twitter.com/personiohr",
    "twitterCreator": "https://twitter.com/personiohr",
    "app": "recipient-portal",
    "languages": ["en", "de"],
    "recipientPortalUrls": ["badges.personio.com"],
    "spotlightUrl": null
  },
  "directory.shiseidoplus.com": {
    "title": "Shiseido Co., Ltd",
    "description": "Shiseido Co., Ltd",
    "identity": "Shiseido Co., Ltd",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.shiseidoplus.com"
  },
  "chromeoscertified.credential.net": {
    "title": "Google ChromeOS Certifications",
    "description": "A Professional ChromeOS Administrator is a systems administrator or junior engineer with 12+ months of holistic IT infrastructure experience. The Professional ChromeOS Administrator should be able to configure, deploy, maintain, troubleshoot, secure, and manage infrastructure and services.",
    "identity": "Google ChromeOS Certifications",
    "spiderable": "all",
    "image": "/assets/themes/chromeoscertified.credential.net/images/seo_image.svg",
    "twitterSite": "google_chromeos",
    "twitterCreator": "google_chromeos",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "chromeoscertified.credential.net"
  },
  "directory.lora-alliance.org": {
    "title": "LoRa Alliance",
    "description": "Lora-Alliance",
    "identity": "Lora-Alliance",
    "spiderable": "all",
    "image": "/assets/themes/directory.lora-alliance.org/images/seo_image.svg",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.lora-alliance.org"
  },
  "badgedirectory.intact.ca": {
    "title": "Intact",
    "description": "Insurance for car, home, business and more ",
    "identity": "Intact",
    "spiderable": "all",
    "image": "/assets/themes/badgedirectory.intact.ca/images/seo_image.png",
    "twitterSite": "@IntactInsurance",
    "twitterCreator": "@IntactInsurance",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "badgedirectory.intact.ca"
  },
  "badges.intact.ca": {
    "title": "Intact",
    "description": "Insurance for car, home, business and more ",
    "identity": "Intact",
    "spiderable": "all",
    "image": "/assets/themes/badges.intact.ca/images/seo_image.png",
    "twitterSite": "@IntactInsurance",
    "twitterCreator": "@IntactInsurance",
    "app": "recipient-portal",
    "languages": ["en", "fr"],
    "recipientPortalUrls": ["badges.intact.ca"],
    "spotlightUrl": null
  },
  "achievement.cengage.com": {
    "title": "Cengage Learning",
    "description": "Cengage helps higher education instructors, learners and institutions thrive with course materials built around their needs. At Cengage, we're here for you.",
    "identity": "Cengage Learning",
    "spiderable": "all",
    "image": "/assets/themes/achievement.cengage.com/images/seo_image.png",
    "twitterSite": "@CengageLearning",
    "twitterCreator": "@CengageLearning",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievement.cengage.com"],
    "spotlightUrl": null
  },
  "badges.plus.columbia.edu": {
    "title": "Columbia Plus",
    "description": "Columbia Plus",
    "identity": "Columbia Plus",
    "spiderable": "all",
    "image": "/assets/themes/badges.plus.columbia.edu/images/seo_image.png",
    "twitterSite": "@Columbia",
    "twitterCreator": "@Columbia",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.plus.columbia.edu"],
    "spotlightUrl": null
  },
  "certificates.teladochealth.com": {
    "title": "Teladoc Health",
    "description": "Whole-Person Care Delivered Virtually",
    "identity": "Teladoc Health",
    "spiderable": "all",
    "image": "/assets/themes/certificates.teladochealth.com/images/seo_image.jpg",
    "twitterSite": "@TeladocHealth",
    "twitterCreator": "@TeladocHealth",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.teladochealth.com"],
    "spotlightUrl": null
  },
  "credentials.trustd.net": {
    "title": "",
    "description": "",
    "identity": "Trustd - Whitelabel Instance",
    "spiderable": "all",
    "image": "/assets/themes/credentials.trustd.net/images/seo_image.svg",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.trustd.net"],
    "spotlightUrl": null
  },
  "gppcertifications.mitel.com": {
    "title": "Mitel Phone System & Contact Center Certifications & Badges | Accredible",
    "description": "See all available official Mitel digital certifications and badges you can earn and display to raise you status on Accredible. Verified by blockchain.",
    "identity": "Mitel",
    "spiderable": "all",
    "image": "/assets/themes/gppcertifications.mitel.com/images/seo_image.png",
    "twitterSite": "https://twitter.com/Mitel",
    "twitterCreator": "https://twitter.com/Mitel",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["gppcertifications.mitel.com"],
    "spotlightUrl": null
  },
  "salescertifications.mitel.com": {
    "title": "Mitel Phone System & Contact Center Certifications & Badges | Accredible",
    "description": "See all available official Mitel digital certifications and badges you can earn and display to raise you status on Accredible. Verified by blockchain.",
    "identity": "Mitel",
    "spiderable": "all",
    "image": "/assets/themes/salescertifications.mitel.com/images/seo_image.png",
    "twitterSite": "https://twitter.com/Mitel",
    "twitterCreator": "https://twitter.com/Mitel",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["salescertifications.mitel.com"],
    "spotlightUrl": null
  },
  "digitalcerts.theabfm.org": {
    "title": "The American Board of Family Medicine",
    "description": "The American Board of Family Medicine",
    "identity": "The American Board of Family Medicine",
    "spiderable": "all",
    "image": "/assets/themes/digitalcerts.theabfm.org/images/seo_image.jpeg",
    "twitterSite": "@TheABFM",
    "twitterCreator": "@TheABFM",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcerts.theabfm.org"],
    "spotlightUrl": null
  },
  "professional.gfps.com": {
    "title": "GFPS Global Academy",
    "description": "GFPS Global Academy",
    "identity": "GFPS Global Academy",
    "spiderable": "all",
    "image": "",
    "twitterSite": "https://twitter.com/georgfischer",
    "twitterCreator": "https://twitter.com/georgfischer",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "professional.gfps.com"
  },
  "certified.goconsensus.com": {
    "title": "Consensus Certified",
    "description": "Consensus Certified - Across the world we’ve got some amazing users, doing amazing things for the people they work with, and the buyers they support.",
    "identity": "Consensus",
    "spiderable": "all",
    "image": "/assets/themes/certified.goconsensus.com/images/seo_image.svg",
    "twitterSite": "@goconsensus",
    "twitterCreator": "@goconsensus",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certified.goconsensus.com"],
    "spotlightUrl": null
  },
  "certs.ine.com": {
    "title": "INE",
    "description": "INE is the premier provider of online training for the IT Industry. INE’s innovative learning solution combines in-depth videos with practical, hands-on exercises",
    "identity": "INE",
    "spiderable": "all",
    "image": "/assets/themes/certs.ine.com/images/seo_image.jpg",
    "twitterSite": "@INE",
    "twitterCreator": "@INE",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certs.ine.com"],
    "spotlightUrl": null
  },
  "achievements.padi.com": {
    "title": "Professional Association of Diving Instructors | PADI",
    "description": "Professional Association of Diving Instructors | PADI",
    "identity": "Professional Association of Diving Instructors | PADI",
    "spiderable": "noindex",
    "image": "/assets/themes/achievements.padi.com/images/seo_image.jpg",
    "twitterSite": "@PADI",
    "twitterCreator": "@PADI",
    "app": "recipient-portal",
    "languages": [
      "en",
      "en-gb",
      "de",
      "es",
      "fr",
      "it",
      "ja",
      "ko",
      "nl",
      "pt-pt",
      "th",
      "zh-cn",
      "zh-tw"
    ],
    "recipientPortalUrls": ["achievements.padi.com"],
    "spotlightUrl": null
  },
  "achievements.gre.org": {
    "title": "Educational Testing Services",
    "description": "As a nonprofit organization, ETS is dedicated to advancing quality and equity in education.",
    "identity": "ETS",
    "spiderable": "all",
    "image": "/assets/themes/achievements.gre.org/images/seo_image.ico",
    "twitterSite": "ETSInsights",
    "twitterCreator": "ETSInsights",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.gre.org"],
    "spotlightUrl": null
  },
  "trustdnetwork.trustd.net": {
    "title": "Trustd",
    "description": "Trustd",
    "identity": "Trustd - Spotlight Directory",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "trustdnetwork.trustd.net"
  },
  "badges.ja.org": {
    "title": "Junior Achievement",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.ja.org"],
    "spotlightUrl": null
  },
  "credentials.clscholarship.org": {
    "title": "Critical Language Scholarship Program",
    "description": "The Critical Language Scholarship (CLS) Program is an immersive summer opportunity for American college and university students to learn languages essential to America's engagement with the world.",
    "identity": "Critical Language Scholarship Program",
    "spiderable": "all",
    "image": "/assets/themes/credentials.clscholarship.org/images/seo_image.png",
    "twitterSite": "@CLSscholarship",
    "twitterCreator": "@CLSscholarship",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.clscholarship.org"],
    "spotlightUrl": null
  },
  "achieve.snowflake.com": {
    "title": "Snowflake",
    "description": "Snowflake isn’t just a great technology company. We’re all about the data—easily enabling governed access to near-infinite amounts of data, and cutting-edge tools, applications, and services. With the Data Cloud, you can collaborate locally and globally to reveal new insights, create previously unforeseen business opportunities, and identify and know your customers in the moment with seamless and relevant experiences.",
    "identity": "Snowflake",
    "spiderable": "all",
    "image": "/assets/themes/achieve.snowflake.com/images/seo_image.png",
    "twitterSite": "@SnowflakeDB",
    "twitterCreator": "@SnowflakeDB",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achieve.snowflake.com"],
    "spotlightUrl": null
  },
  "certifications.gohighlevel.com": {
    "title": "HighLevel",
    "description": "HighLevel",
    "identity": "HighLevel",
    "spiderable": "all",
    "image": "/assets/themes/certifications.gohighlevel.com/images/seo_image.png",
    "twitterSite": "@gohighlevel",
    "twitterCreator": "@gohighlevel",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.gohighlevel.com"],
    "spotlightUrl": "directory.gohighlevel.com"
  },
  "directory.gohighlevel.com": {
    "title": "HighLevel",
    "description": "HighLevel",
    "identity": "HighLevel",
    "spiderable": "all",
    "image": "/assets/themes/directory.gohighlevel.com/images/seo_image.png",
    "twitterSite": "@gohighlevel",
    "twitterCreator": "@gohighlevel",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.gohighlevel.com"],
    "spotlightUrl": "directory.gohighlevel.com"
  },
  "credentials.sae.org": {
    "title": "SAE International",
    "description": "Learn - SAE International",
    "identity": "SAE International",
    "spiderable": "all",
    "image": "/assets/themes/credentials.sae.org/images/seo_image.png",
    "twitterSite": "@SAEIntl",
    "twitterCreator": "@SAEIntl",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.sae.org"],
    "spotlightUrl": null
  },
  "directory.snowflake.com": {
    "title": "Snowflake",
    "description": "Snowflake isn’t just a great technology company. We’re all about the data—easily enabling governed access to near-infinite amounts of data, and cutting-edge tools, applications, and services. With the Data Cloud, you can collaborate locally and globally to reveal new insights, create previously unforeseen business opportunities, and identify and know your customers in the moment with seamless and relevant experiences.",
    "identity": "Snowflake",
    "spiderable": "all",
    "image": "/assets/themes/directory.snowflake.com/images/seo_image.png",
    "twitterSite": "@SnowflakeDB",
    "twitterCreator": "@SnowflakeDB",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.snowflake.com"
  },
  "spnbadges.snowflake.com": {
    "title": "Snowflakehubspot",
    "description": "Snowflake isn’t just a great technology company. We’re all about the data—easily enabling governed access to near-infinite amounts of data, and cutting-edge tools, applications, and services. With the Data Cloud, you can collaborate locally and globally to reveal new insights, create previously unforeseen business opportunities, and identify and know your customers in the moment with seamless and relevant experiences.",
    "identity": "Snowflake",
    "spiderable": "all",
    "image": "/assets/themes/spnbadges.snowflake.com/images/seo_image.png",
    "twitterSite": "@SnowflakeDB",
    "twitterCreator": "@SnowflakeDB",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["spnbadges.snowflake.com"],
    "spotlightUrl": null
  },
  "certificates.niflearn.com": {
    "title": "NifLearn",
    "description": "NifLearn",
    "identity": "NifLearn",
    "spiderable": "all",
    "image": "/assets/themes/certificates.niflearn.com/images/seo_image.png",
    "twitterSite": "@NifLearn",
    "twitterCreator": "@NifLearn",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.niflearn.com"],
    "spotlightUrl": null
  },
  "digitalcredentials.cityandguilds.com": {
    "title": "City & Guilds",
    "description": "For over 140 years we have worked with people, organisations and economies to help them identify and develop the skills they need to thrive. We understand the life changing link between skills development, social mobility, prosperity and success.",
    "identity": "City & Guilds",
    "spiderable": "all",
    "image": "/assets/themes/digitalcredentials.cityandguilds.com/images/seo_image.png",
    "twitterSite": "@cityandguilds",
    "twitterCreator": "@cityandguilds",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.cityandguilds.com"],
    "spotlightUrl": null
  },
  "evcregister.evolveadvice.co.uk": {
    "title": "Evolve Advice",
    "description": "Evolve Advice",
    "identity": "Evolve Advice",
    "spiderable": "all",
    "image": "/assets/themes/evcregister.evolveadvice.co.uk/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "evcregister.evolveadvice.co.uk"
  },
  "certify.sbs.ox.ac.uk": {
    "title": "Said Business School",
    "description": "Said Business School",
    "identity": "Said Business School",
    "spiderable": "all",
    "image": "/assets/themes/certify.sbs.ox.ac.uk/images/seo_image.jpeg",
    "twitterSite": "https://twitter.com/oxfordsbs",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certify.sbs.ox.ac.uk"],
    "spotlightUrl": null
  },
  "certificates.conted.ox.ac.uk": {
    "title": "Gain an Oxford qualification | Oxford University Department for Continuing Education",
    "description": "Requiring one or more years of part-time study, these courses lead to an award from the University of Oxford.",
    "identity": "UoO Continued Education - Whitelabel",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.conted.ox.ac.uk"],
    "spotlightUrl": null
  },
  "credentials.english.britishcouncil.org": {
    "title": "British Council",
    "description": "The British Council is the United Kingdom’s international organisation for cultural relations and educational opportunities.",
    "identity": "British Council",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@BritishCouncil",
    "twitterCreator": "@BritishCouncil",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.english.britishcouncil.org"],
    "spotlightUrl": null
  },
  "digitalcredentials.i-l-m.com": {
    "title": "ILM",
    "description": "Join the thousands of other people who enhanced their performance with an ILM qualification last year, and fast-track your way to the top with our leadership and management qualifications. Ranging from Levels 2 to 7, our qualifications cater to all levels of management and offer a clear route to career progression.",
    "identity": "ILM",
    "spiderable": "all",
    "image": "/assets/themes/digitalcredentials.i-l-m.com/images/seo_image.png",
    "twitterSite": "@ILM_UK",
    "twitterCreator": "@ILM_UK",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.i-l-m.com"],
    "spotlightUrl": null
  },
  "credentials.cips.org": {
    "title": "Chartered Institute of Procurement & Supply",
    "description": "Chartered Institute of Procurement & Supply",
    "identity": "Chartered Institute of Procurement & Supply",
    "spiderable": "all",
    "image": "/assets/themes/credentials.cips.org/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.cips.org"],
    "spotlightUrl": null
  },
  "digitalcredentials.cityandguildsfoundation.org": {
    "title": "City & Guilds Foundation",
    "description": "The City & Guilds Foundation is part of City & Guilds, global pioneers in skills development. We support over 4 million people each year to develop skills that help them into a job, develop on that job and to prepare for their next job. As a charity, we’re proud that everything we do is focused on achieving this purpose.",
    "identity": "City & Guilds Foundation",
    "spiderable": "all",
    "image": "/assets/themes/digitalcredentials.cityandguildsfoundation.org/images/seo_image.svg",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.cityandguildsfoundation.org"],
    "spotlightUrl": null
  },
  "certificates.nbcot.org": {
    "title": "NBCOT",
    "description": "NBCOT",
    "identity": "NBCOT",
    "spiderable": "all",
    "image": "/assets/themes/certificates.nbcot.org/images/seo_image.png",
    "twitterSite": "@NBCOT",
    "twitterCreator": "@NBCOT",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.nbcot.org"],
    "spotlightUrl": null
  },
  "digitalcredentials.kineo.com": {
    "title": "Kineo",
    "description": "We live and breathe great learning.  Instructional design and data-driven thinking runs through everything we do.  Whether it’s a platform, a course or blended learning, we’ll work with you to understand and meet your learning and development needs.  And ultimately, help you to achieve your business goals. ",
    "identity": "Kineo",
    "spiderable": "all",
    "image": "/assets/themes/digitalcredentials.kineo.com/images/seo_image.ico",
    "twitterSite": "@Kineo",
    "twitterCreator": "@Kineo",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.kineo.com"],
    "spotlightUrl": null
  },
  "directory.imta.org": {
    "title": "International Mindfulness Teachers Association",
    "description": "International Mindfulness Teachers Association",
    "identity": "International Mindfulness Teachers Association",
    "spiderable": "all",
    "image": "/assets/themes/directory.imta.org/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.imta.org"
  },
  "badges.ucr.edu": {
    "title": "UC Riverside",
    "description": "University of California, Riverside",
    "identity": "UC Riverside",
    "spiderable": "all",
    "image": "/assets/themes/badges.ucr.edu/images/seo_image.png",
    "twitterSite": "@UCRiverside",
    "twitterCreator": "@UCRiverside",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.ucr.edu"],
    "spotlightUrl": null
  },
  "digitalcredentials.oxford-group.com": {
    "title": "The Oxford Group",
    "description": "The Oxford Group",
    "identity": "The Oxford Group",
    "spiderable": "all",
    "image": "/assets/themes/digitalcredentials.oxford-group.com/images/seo_image.svg",
    "twitterSite": "@The_OxfordGroup",
    "twitterCreator": "@The_OxfordGroup",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.oxford-group.com"],
    "spotlightUrl": null
  },
  "achievements.ets.org": {
    "title": "Educational Testing Services",
    "description": "As a nonprofit organization, ETS is dedicated to advancing quality and equity in education.",
    "identity": "ETS",
    "spiderable": "all",
    "image": "/assets/themes/achievements.ets.org/images/seo_image.ico",
    "twitterSite": "ETSInsights",
    "twitterCreator": "ETSInsights",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.ets.org"],
    "spotlightUrl": null
  },
  "credentials.corporate.britishcouncil.org": {
    "title": "Learn English Online - British Council",
    "description": "Are you learning English? The British Council has thousands of high-quality resources to help you improve your English and help your children Learn English.",
    "identity": "Learn English Online - British Council",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@LearnEnglish_BC",
    "twitterCreator": "@English_BC",
    "app": "recipient-portal",
    "languages": ["en-gb"],
    "recipientPortalUrls": ["credentials.corporate.britishcouncil.org"],
    "spotlightUrl": null
  },
  "certificates.navc.com": {
    "title": "North American Veterinary Community | NAVC",
    "description": "North American Veterinary Community",
    "identity": "North American Veterinary Community",
    "spiderable": "all",
    "image": "/assets/themes/certificates.navc.com/images/seo_image.png",
    "twitterSite": "@The_NAVC",
    "twitterCreator": "@The_NAVC",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.navc.com"],
    "spotlightUrl": null,
    "samlSsoUrl": "https://go.navc.com/certificates"
  },
  "digitalcredentials.cityandguildstraining.com": {
    "title": "City & Guilds",
    "description": "For over 140 years we have worked with people, organisations and economies to help them identify and develop the skills they need to thrive. We understand the life changing link between skills development, social mobility, prosperity and success.",
    "identity": "City & Guilds",
    "spiderable": "all",
    "image": "/assets/themes/digitalcredentials.cityandguildstraining.com/images/seo_image.png",
    "twitterSite": "@cityandguilds",
    "twitterCreator": "@cityandguilds",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.cityandguildstraining.com"],
    "spotlightUrl": null
  },
  "certifications.issaonline.com": {
    "title": "International Sports Sciences Association",
    "description": "International Sports Sciences Association - Recipient Portal",
    "identity": "ISSA (certifications.issaonline.com)",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.issaonline.com"],
    "spotlightUrl": null
  },
  "edu.google.accredible.com": {
    "title": "Google for Education",
    "description": "Use Google tools together to drive educational impact.",
    "identity": "Google for Education",
    "spiderable": "all",
    "image": "/assets/themes/edu.google.accredible.com/images/seo_image.png",
    "twitterSite": "@GoogleForEdu",
    "twitterCreator": "@GoogleForEdu",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["edu.google.accredible.com"],
    "spotlightUrl": null
  },
  "certificates.alixpartners.com": {
    "title": "AlixPartners",
    "description": "AlixPartners",
    "identity": "AlixPartners",
    "spiderable": "all",
    "image": "/assets/themes/certificates.alixpartners.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.alixpartners.com"],
    "spotlightUrl": null
  },
  "professionalregister.cips.org": {
    "title": "Chartered Institute of Procurement & Supply",
    "description": "Chartered Institute of Procurement & Supply",
    "identity": "Chartered Institute of Procurement & Supply",
    "spiderable": "all",
    "image": "/assets/themes/professionalregister.cips.org/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.cips.org"],
    "spotlightUrl": "professionalregister.cips.org"
  },
  "directory.integrativenutrition.com": {
    "title": "Institute for Integrative Nutrition",
    "description": "Institute for Integrative Nutrition",
    "identity": "Institute for Integrative Nutrition",
    "spiderable": "all",
    "image": "/assets/themes/directory.integrativenutrition.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.integrativenutrition.com"
  },
  "certificates.csuohio.edu": {
    "title": "Cleveland State University",
    "description": "Cleveland State University",
    "identity": "Cleveland State University",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.csuohio.edu"],
    "spotlightUrl": null
  },
  "achievements.bellevue.edu": {
    "title": "Bellevue University",
    "description": "Bellevue University",
    "identity": "Bellevue",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.bellevue.edu"],
    "spotlightUrl": null
  },
  "spotlight.biotility.research.ufl.edu": {
    "title": "Biotility Digital Credentials ",
    "description": "Biotility offers pathways for individuals seeking to jumpstart or advance their career in the bioscience and biotech industries, including several industry-recognized certifications and credentials. Browse our showcase of certified industry professionals!",
    "identity": "Biotility Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/spotlight.biotility.research.ufl.edu/images/seo_image.png",
    "twitterSite": "@Biotility",
    "twitterCreator": "@Biotility",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "spotlight.biotility.research.ufl.edu"
  },
  "certifications.asana.com": {
    "title": "Asana",
    "description": "Asana Digital Credentials",
    "identity": "Asana",
    "spiderable": "all",
    "image": "/assets/themes/certifications.asana.com/images/seo_image.png",
    "twitterSite": "@asana",
    "twitterCreator": "@asana",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.asana.com"],
    "spotlightUrl": null
  },
  "directory.mycollectivehub.com": {
    "title": "The Collective Directory",
    "description": "Your free, public directory of certified coaches",
    "identity": "The Collective Directory",
    "spiderable": "all",
    "image": "/assets/themes/directory.mycollectivehub.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.mycollectivehub.com"
  },
  "certificates.wbd.com": {
    "title": "Warner Bros. Discovery",
    "description": "Warner Bros. Discovery",
    "identity": "Warner Bros. Discovery",
    "spiderable": "all",
    "image": "/assets/themes/certificates.wbd.com/images/seo_image.jpg",
    "twitterSite": "@wbd",
    "twitterCreator": "@wbd",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.wbd.com"],
    "spotlightUrl": null
  },
  "expertsdirectory.cloudinary.com": {
    "title": "Cloudinary Experts Directory",
    "description": "Cloudinary Digital Credentials",
    "identity": "Cloudinary",
    "spiderable": "all",
    "image": "/assets/themes/expertsdirectory.cloudinary.com/images/seo_image.png",
    "twitterSite": "@cloudinary",
    "twitterCreator": "@cloudinary",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "expertsdirectory.cloudinary.com"
  },
  "employment.healthyworkcompany.com": {
    "title": "The Healthy Work Company",
    "description": "The Healthy Work Company",
    "identity": "The Healthy Work Company",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "employment.healthyworkcompany.com"
  },
  "credentials.aicd.com.au": {
    "title": "Australian Institute of Company Directors",
    "description": "Australian Institute of Company Directors",
    "identity": "Australian Institute of Company Directors",
    "spiderable": "all",
    "image": "/assets/themes/credentials.aicd.com.au/images/seo_image.png",
    "twitterSite": "@AICDirectors",
    "twitterCreator": "@AICDirectors",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.aicd.com.au"],
    "spotlightUrl": null
  },
  "certificates.icaew.com": {
    "title": "ICAEW",
    "description": "Institute of Chartered Accountants in England and Wales",
    "identity": "ICAEW - Recipient Portal",
    "spiderable": "all",
    "image": "/assets/themes/certificates.icaew.com/images/seo_image.png",
    "twitterSite": "https://twitter.com/icaew",
    "twitterCreator": "https://twitter.com/icaew",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.icaew.com"],
    "spotlightUrl": null
  },
  "chromeoscertifieddirectory.accredible.com": {
    "title": "Google ChromeOS Certifications",
    "description": "A Professional ChromeOS Administrator is a systems administrator or junior engineer with 12+ months of holistic IT infrastructure experience. The Professional ChromeOS Administrator should be able to configure, deploy, maintain, troubleshoot, secure, and manage infrastructure and services.",
    "identity": "Google ChromeOS Certifications",
    "spiderable": "all",
    "image": "/assets/themes/chromeoscertifieddirectory.accredible.com/images/seo_image.svg",
    "twitterSite": "google_chromeos",
    "twitterCreator": "google_chromeos",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "chromeoscertifieddirectory.accredible.com"
  },
  "directory.acs.org": {
    "title": "ACS Global Community Directory",
    "description": "Discover and connect with leading chemistry professionals across various fields",
    "identity": "ACS Global Community Directory",
    "spiderable": "all",
    "image": "/assets/themes/directory.acs.org/images/seo_image.png",
    "twitterSite": "@AmerChemSociety",
    "twitterCreator": "@AmerChemSociety",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.acs.org"
  },
  "certificates.bettercertify.com": {
    "title": "BetterCertify",
    "description": "BetterCertify",
    "identity": "BetterCertify",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "certificates.bettercertify.com"
  },
  "asugsvsummit.accredible.com": {
    "title": "ASU+GSV Summit 2024",
    "description": "ASU+GSV Summit 2024",
    "identity": "ASU+GSV Summit 2024",
    "spiderable": "all",
    "image": "/assets/themes/asugsvsummit.accredible.com/images/seo_image.png",
    "twitterSite": "@asugsvsummit",
    "twitterCreator": "@asugsvsummit",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["asugsvsummit.accredible.com"],
    "spotlightUrl": null
  },
  "credential.oet.com": {
    "title": "OET",
    "description": "Occupational English Test",
    "identity": "OET - Recipient Portal ",
    "spiderable": "all",
    "image": "/assets/themes/credential.oet.com/images/seo_image.png",
    "twitterSite": "@OETOfficial",
    "twitterCreator": "@OETOfficia",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credential.oet.com"],
    "spotlightUrl": null
  },
  "badges.swva.ja.org": {
    "title": "Junior Achievement",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.swva.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.swva.ja.org"],
    "spotlightUrl": null
  },
  "badges.southeasternpa.ja.org": {
    "title": "Junior Achievement",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.southeasternpa.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southeasternpa.ja.org"],
    "spotlightUrl": null
  },
  "badges.westernnewyork.ja.org": {
    "title": "Junior Achievement",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.westernnewyork.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.westernnewyork.ja.org"],
    "spotlightUrl": null
  },
  "badges.norcal.ja.org": {
    "title": "Junior Achievement",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.norcal.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.norcal.ja.org"],
    "spotlightUrl": null
  },
  "badges.southernma.ja.org": {
    "title": "Junior Achievement",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.southernma.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southernma.ja.org"],
    "spotlightUrl": null
  },
  "credentials.bellevue.edu": {
    "title": "Bellevue University",
    "description": "Bellevue University",
    "identity": "Bellevue University",
    "spiderable": "all",
    "image": "/assets/themes/credentials.bellevue.edu/images/seo_image.png",
    "twitterSite": "BellevueU",
    "twitterCreator": "BellevueU",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "credentials.bellevue.edu"
  },
  "credentials.nicet.org": {
    "title": "NATIONAL INSTITUTE FOR CERTIFICATION IN ENGINEERING TECHNOLOGIES",
    "description": "NATIONAL INSTITUTE FOR CERTIFICATION IN ENGINEERING TECHNOLOGIES",
    "identity": "NATIONAL INSTITUTE FOR CERTIFICATION IN ENGINEERING TECHNOLOGIES",
    "spiderable": "all",
    "image": "/assets/themes/credentials.nicet.org/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.nicet.org"],
    "spotlightUrl": null
  },
  "certified.fulbright.edu.vn": {
    "title": "Fulbright University Vietnam",
    "description": "Fulbright University Vietnam",
    "identity": "Fulbright University Vietnam",
    "spiderable": "all",
    "image": "/assets/themes/certified.fulbright.edu.vn/images/seo_image.ico",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "recipientPortalUrls": ["certified.fulbright.edu.vn"],
    "spotlightUrl": null
  },
  "chromeoscertified.accredible.com": {
    "title": "Google ChromeOS Certifications",
    "description": "A Professional ChromeOS Administrator is a systems administrator or junior engineer with 12+ months of holistic IT infrastructure experience. The Professional ChromeOS Administrator should be able to configure, deploy, maintain, troubleshoot, secure, and manage infrastructure and services.",
    "identity": "Google ChromeOS Certifications",
    "spiderable": "all",
    "image": "/assets/themes/chromeoscertified.accredible.com/images/seo_image.svg",
    "twitterSite": "google_chromeos",
    "twitterCreator": "google_chromeos",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["chromeoscertified.accredible.com"],
    "spotlightUrl": null
  },
  "credentialdirectory.sae.org": {
    "title": "SAE International",
    "description": "Learn - SAE International",
    "identity": "SAE International",
    "spiderable": "all",
    "image": "/assets/themes/credentialdirectory.sae.org/images/seo_image.png",
    "twitterSite": "@SAEIntl",
    "twitterCreator": "@SAEIntl",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "credentialdirectory.sae.org"
  },
  "alumni.itcilo.org": {
    "title": "ITCILO Alumni Network",
    "description": "The ITCILO Alumni Network connects former participants of ITCILO programmes, fostering a global community of professionals dedicated to sustainable development and promoting social justice through decent work. This platform offers ITCILO alumni focused networking opportunities, and professional development possibilities. The platform supports ongoing collaboration, and career advancement, reinforcing the commitment to lifelong learning and the mission of promoting social justice and decent work worldwide.",
    "identity": "ITCILO Alumni Network",
    "spiderable": "all",
    "image": "/assets/themes/alumni.itcilo.org/images/seo_image.png",
    "twitterSite": "https://x.com/ITCILO",
    "twitterCreator": "@ITCILO",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "alumni.itcilo.org"
  },
  "accredible.credential.net": {
    "title": "Accredible",
    "description": "Accredible",
    "identity": "Accredible",
    "spiderable": "all",
    "image": "/assets/themes/accredible.credential.net/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["accredible.credential.net"],
    "spotlightUrl": null
  },
  "certification.wallstreetprep.com": {
    "title": "Wallstreetprep",
    "description": "Wallstreetprep Recipient Portal",
    "identity": "Wallstreetprep",
    "spiderable": "noindex, nofollow",
    "image": "/assets/themes/certification.wallstreetprep.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certification.wallstreetprep.com"],
    "spotlightUrl": null
  },
  "certificates.toptiertrader.com": {
    "title": "TopTier Trading",
    "description": "TopTier Trading",
    "identity": "TopTier Trading",
    "spiderable": "noindex, nofollow",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.toptiertrader.com"],
    "spotlightUrl": null
  },
  "badges.georgia.ja.org": {
    "title": "Junior Achievement of Georgia",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.georgia.ja.org"],
    "spotlightUrl": null
  },
  "badges.northernnevada.ja.org": {
    "title": "Junior Achievement of Northern Nevada",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.northernnevada.ja.org"],
    "spotlightUrl": null
  },
  "badges.swindiana.ja.org": {
    "title": "Junior Achievement of Southwest Indiana",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.swindiana.ja.org"],
    "spotlightUrl": null
  },
  "badges.delaware.ja.org": {
    "title": "Junior Achievement of Delaware",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.delaware.ja.org"],
    "spotlightUrl": null
  },
  "badges.jawm.ja.org": {
    "title": "Junior Achievement of Western Massachusetts",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jawm.ja.org"],
    "spotlightUrl": null
  },
  "badges.cleveland.ja.org": {
    "title": "Junior Achievement of Cleveland",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.cleveland.ja.org"],
    "spotlightUrl": null
  },
  "badges.newyork.ja.org": {
    "title": "Junior Achievement of New York",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.newyork.ja.org"],
    "spotlightUrl": null
  },
  "badges.greaterwashington.ja.org": {
    "title": "Junior Achievement of Greater Washington",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.greaterwashington.ja.org"],
    "spotlightUrl": null
  },
  "badges.hawaii.ja.org": {
    "title": "Junior Achievement of Hawaii",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.hawaii.ja.org"],
    "spotlightUrl": null
  },
  "badges.spacecoast.ja.org": {
    "title": "Junior Achievement of Space Coast",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.spacecoast.ja.org"],
    "spotlightUrl": null
  },
  "badges.greatersc.ja.org": {
    "title": "Junior Achievement of Greater South Carolina",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.greatersc.ja.org"],
    "spotlightUrl": null
  },
  "badges.socal.ja.org": {
    "title": "Junior Achievement of Southern California",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.socal.ja.org"],
    "spotlightUrl": null
  },
  "badges.colorado.ja.org": {
    "title": "Junior Achievement of Colorado",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.colorado.ja.org"],
    "spotlightUrl": null
  },
  "badges.janj.ja.org": {
    "title": "Junior Achievement of New Jersey",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.janj.ja.org"],
    "spotlightUrl": null
  },
  "badges.arkansas.ja.org": {
    "title": "Junior Achievement of Arkansas",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.arkansas.ja.org"],
    "spotlightUrl": null
  },
  "badges.northcentralmi.ja.org": {
    "title": "Junior Achievement of North Central Michigan",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.northcentralmi.ja.org"],
    "spotlightUrl": null
  },
  "badges.northflorida.ja.org": {
    "title": "Junior Achievement of North Florida",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.northflorida.ja.org"],
    "spotlightUrl": null
  },
  "badges.encarolina.ja.org": {
    "title": "Junior Achievement of Eastern North Carolina",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.encarolina.ja.org"],
    "spotlightUrl": null
  },
  "badges.centralva.ja.org": {
    "title": "Junior Achievement of Central Virginia",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centralva.ja.org"],
    "spotlightUrl": null
  },
  "badges.southflorida.ja.org": {
    "title": "Junior Achievement of South Florida",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southflorida.ja.org"],
    "spotlightUrl": null
  },
  "badges.westernpa.ja.org": {
    "title": "Junior Achievement of Western Pennsylvania",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.westernpa.ja.org"],
    "spotlightUrl": null
  },
  "badges.alabama.ja.org": {
    "title": "Junior Achievement of Alabama",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.alabama.ja.org"],
    "spotlightUrl": null
  },
  "badges.heartland.ja.org": {
    "title": "Junior Achievement of Heartland",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.heartland.ja.org"],
    "spotlightUrl": null
  },
  "badges.palmbeachtreasurecoast.ja.org": {
    "title": "Junior Achievement of Palm Beach Treasure Coast",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.palmbeachtreasurecoast.ja.org"],
    "spotlightUrl": null
  },
  "badges.swne.ja.org": {
    "title": "Junior Achievement of Southwest New England",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.swne.ja.org"],
    "spotlightUrl": null
  },
  "badges.southcentralkentucky.ja.org": {
    "title": "Junior Achievement of Southcentral Kentucky",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southcentralkentucky.ja.org"],
    "spotlightUrl": null
  },
  "badges.soco.ja.org": {
    "title": "Junior Achievement of Southern Colorado",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.soco.ja.org"],
    "spotlightUrl": null
  },
  "badges.az.ja.org": {
    "title": "Junior Achievement of Arizona",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.az.ja.org"],
    "spotlightUrl": null
  },
  "badges.easternohio.ja.org": {
    "title": "Junior Achievement of Eastern Ohio",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.easternohio.ja.org"],
    "spotlightUrl": null
  },
  "badges.dallas.ja.org": {
    "title": "Junior Achievement of Dallas",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.dallas.ja.org"],
    "spotlightUrl": null
  },
  "badges.neny.ja.org": {
    "title": "Junior Achievement of Northeastern New York",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.neny.ja.org"],
    "spotlightUrl": null
  },
  "badges.hamptonroads.ja.org": {
    "title": "Junior Achievement of Hampton Roads",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.hamptonroads.ja.org"],
    "spotlightUrl": null
  },
  "badges.greaterboston.ja.org": {
    "title": "Junior Achievement of Greater Boston",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.greaterboston.ja.org"],
    "spotlightUrl": null
  },
  "badges.ky.ja.org": {
    "title": "Junior Achievement of Kayman Islands",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.ky.ja.org"],
    "spotlightUrl": null
  },
  "badges.kansas.ja.org": {
    "title": "Junior Achievement of Kansas",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.kansas.ja.org"],
    "spotlightUrl": null
  },
  "badges.alaska.ja.org": {
    "title": "Junior Achievement of Alaska",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.alaska.ja.org"],
    "spotlightUrl": null
  },
  "badges.sandiego.ja.org": {
    "title": "Junior Achievement of San Diego",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.sandiego.ja.org"],
    "spotlightUrl": null
  },
  "badges.sacramento.ja.org": {
    "title": "Junior Achievement of Sacramento",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.sacramento.ja.org"],
    "spotlightUrl": null
  },
  "badges.jagfc.ja.org": {
    "title": "Junior Achievement of Greater Fairfield County",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jagfc.ja.org"],
    "spotlightUrl": null
  },
  "badges.miami.ja.org": {
    "title": "Junior Achievement of Miami",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.miami.ja.org"],
    "spotlightUrl": null
  },
  "badges.centralfl.ja.org": {
    "title": "Junior Achievement of Central Florida",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centralfl.ja.org"],
    "spotlightUrl": null
  },
  "badges.tampabay.ja.org": {
    "title": "Junior Achievement of Tampa Bay",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.tampabay.ja.org"],
    "spotlightUrl": null
  },
  "badges.southwestflorida.ja.org": {
    "title": "Junior Achievement of Southwest Florida",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southwestflorida.ja.org"],
    "spotlightUrl": null
  },
  "badges.centraliowa.ja.org": {
    "title": "Junior Achievement of Central Iowa",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centraliowa.ja.org"],
    "spotlightUrl": null
  },
  "badges.easterniowa.ja.org": {
    "title": "Junior Achievement of Eastern Iowa",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.easterniowa.ja.org"],
    "spotlightUrl": null
  },
  "badges.chicago.ja.org": {
    "title": "Junior Achievement of Chicago",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.chicago.ja.org"],
    "spotlightUrl": null
  },
  "badges.washington.ja.org": {
    "title": "Junior Achievement of Washington",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.washington.ja.org"],
    "spotlightUrl": null
  },
  "badges.centralillinois.ja.org": {
    "title": "Junior Achievement of Central llinois",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centralillinois.ja.org"],
    "spotlightUrl": null
  },
  "badges.michiganedge.ja.org": {
    "title": "Junior Achievement of Michigan Edge",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.michiganedge.ja.org"],
    "spotlightUrl": null
  },
  "badges.indy.ja.org": {
    "title": "Junior Achievement of Indy",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.indy.ja.org"],
    "spotlightUrl": null
  },
  "badges.toledo.ja.org": {
    "title": "Junior Achievement of Toledo",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.toledo.ja.org"],
    "spotlightUrl": null
  },
  "badges.bluegrass.ja.org": {
    "title": "Junior Achievement of Bluegrass",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.bluegrass.ja.org"],
    "spotlightUrl": null
  },
  "badges.owensboro.ja.org": {
    "title": "Junior Achievement of Owensboro",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.owensboro.ja.org"],
    "spotlightUrl": null
  },
  "badges.batonrouge.ja.org": {
    "title": "Junior Achievement of Baton Rouge",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.batonrouge.ja.org"],
    "spotlightUrl": null
  },
  "badges.jaofnco.ja.org": {
    "title": "Junior Achievement of North Central Ohio",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jaofnco.ja.org"],
    "spotlightUrl": null
  },
  "badges.jagno.ja.org": {
    "title": "Junior Achievement of Greater New Orleans",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jagno.ja.org"],
    "spotlightUrl": null
  },
  "badges.nla.ja.org": {
    "title": "Junior Achievement of North Louisiana",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.nla.ja.org"],
    "spotlightUrl": null
  },
  "badges.tricities.ja.org": {
    "title": "Junior Achievement of Tri-Cities",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.tricities.ja.org"],
    "spotlightUrl": null
  },
  "badges.easttennessee.ja.org": {
    "title": "Junior Achievement of Eastern Tennessee",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.easttennessee.ja.org"],
    "spotlightUrl": null
  },
  "badges.centralmaryland.ja.org": {
    "title": "Junior Achievement of Central Maryland",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centralmaryland.ja.org"],
    "spotlightUrl": null
  },
  "badges.easternshore.ja.org": {
    "title": "Junior Achievement of Eastern Shore",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.easternshore.ja.org"],
    "spotlightUrl": null
  },
  "badges.maine.ja.org": {
    "title": "Junior Achievement of Maine",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.maine.ja.org"],
    "spotlightUrl": null
  },
  "badges.michigan.ja.org": {
    "title": "Junior Achievement of Michigan",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.michigan.ja.org"],
    "spotlightUrl": null
  },
  "badges.elpaso.ja.org": {
    "title": "Junior Achievement of El Paso",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.elpaso.ja.org"],
    "spotlightUrl": null
  },
  "badges.westmichigan.ja.org": {
    "title": "Junior Achievement of West Michigan",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.westmichigan.ja.org"],
    "spotlightUrl": null
  },
  "badges.north.ja.org": {
    "title": "Junior Achievement of North",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.north.ja.org"],
    "spotlightUrl": null
  },
  "badges.jagkc.ja.org": {
    "title": "Junior Achievement of Greater Kansas City",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jagkc.ja.org"],
    "spotlightUrl": null
  },
  "badges.greaterstlouis.ja.org": {
    "title": "Junior Achievement of Greater St. Louis",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.greaterstlouis.ja.org"],
    "spotlightUrl": null
  },
  "badges.lincoln.ja.org": {
    "title": "Junior Achievement of Lincoln",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.lincoln.ja.org"],
    "spotlightUrl": null
  },
  "badges.centralcarolinas.ja.org": {
    "title": "Junior Achievement of Central Carolina",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centralcarolinas.ja.org"],
    "spotlightUrl": null
  },
  "badges.triad.ja.org": {
    "title": "Junior Achievement of the Triad",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.triad.ja.org"],
    "spotlightUrl": null
  },
  "badges.jaomaha.ja.org": {
    "title": "Junior Achievement of Omaha",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jaomaha.ja.org"],
    "spotlightUrl": null
  },
  "badges.jaorswwa.ja.org": {
    "title": "Junior Achievement of Oregon & SW Washington",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jaorswwa.ja.org"],
    "spotlightUrl": null
  },
  "badges.newmexico.ja.org": {
    "title": "Junior Achievement of New Mexico",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.newmexico.ja.org"],
    "spotlightUrl": null
  },
  "badges.southernnevada.ja.org": {
    "title": "Junior Achievement of Southern Nevada",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southernnevada.ja.org"],
    "spotlightUrl": null
  },
  "badges.cuny.ja.org": {
    "title": "Junior Achievement of Central Upstate New York",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.cuny.ja.org"],
    "spotlightUrl": null
  },
  "badges.centralohio.ja.org": {
    "title": "Junior Achievement of Central Ohio",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.centralohio.ja.org"],
    "spotlightUrl": null
  },
  "badges.ocoeeregion.ja.org": {
    "title": "Junior Achievement of Ocoee Region",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.ocoeeregion.ja.org"],
    "spotlightUrl": null
  },
  "badges.middletownarea.ja.org": {
    "title": "Junior Achievement of Middle Town Area",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.middletownarea.ja.org"],
    "spotlightUrl": null
  },
  "badges.madriver.ja.org": {
    "title": "Junior Achievement of Mad River Region",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.madriver.ja.org"],
    "spotlightUrl": null
  },
  "badges.okipartners.ja.org": {
    "title": "Junior Achievement of OKI Partners",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.okipartners.ja.org"],
    "spotlightUrl": null
  },
  "badges.oklahoma.ja.org": {
    "title": "Junior Achievement of Oklahoma",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.oklahoma.ja.org"],
    "spotlightUrl": null
  },
  "badges.nepa.ja.org": {
    "title": "Junior Achievement of Northeastern Pennsylvania",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.nepa.ja.org"],
    "spotlightUrl": null
  },
  "badges.nashville.ja.org": {
    "title": "Junior Achievement of Nashville",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.nashville.ja.org"],
    "spotlightUrl": null
  },
  "badges.rhodeisland.ja.org": {
    "title": "Junior Achievement of Rhode Island",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.rhodeisland.ja.org"],
    "spotlightUrl": null
  },
  "badges.southdakota.ja.org": {
    "title": "Junior Achievement of South Dakota",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.southdakota.ja.org"],
    "spotlightUrl": null
  },
  "badges.chattanooga.ja.org": {
    "title": "Junior Achievement of Chattanooga",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.chattanooga.ja.org"],
    "spotlightUrl": null
  },
  "badges.memphis.ja.org": {
    "title": "Junior Achievement of Memphis",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.memphis.ja.org"],
    "spotlightUrl": null
  },
  "badges.brazoriacounty.ja.org": {
    "title": "Junior Achievement of Brazoria County",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.brazoriacounty.ja.org"],
    "spotlightUrl": null
  },
  "badges.chisholmtrail.ja.org": {
    "title": "Junior Achievement of Chisholm Trail",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.chisholmtrail.ja.org"],
    "spotlightUrl": null
  },
  "badges.houston.ja.org": {
    "title": "Junior Achievement of Houston",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.houston.ja.org"],
    "spotlightUrl": null
  },
  "badges.jast.ja.org": {
    "title": "Junior Achievement of South Texas",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jast.ja.org"],
    "spotlightUrl": null
  },
  "badges.utah.ja.org": {
    "title": "Junior Achievement of Utah",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.utah.ja.org"],
    "spotlightUrl": null
  },
  "badges.wisconsin.ja.org": {
    "title": "Junior Achievement of Wisconsin",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.wisconsin.ja.org"],
    "spotlightUrl": null
  },
  "badges.northernindiana.ja.org": {
    "title": "Junior Achievement of Northern Indiana",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.northernindiana.ja.org"],
    "spotlightUrl": null
  },
  "badges.jascpa.ja.org": {
    "title": "Junior Achievement of South Central PA",
    "description": "Junior Achievement has over 100 local JA Areas across the nation, and together we are the nation's largest organization dedicated to giving young people the knowledge and skills they need to own their economic success, plan for their futures, and make smart academic and economic choices. JA's programs—in the core content areas of work readiness, entrepreneurship and financial literacy—ignite the spark in young people to experience and realize the opportunities and realities of work and life in the 21st century.",
    "identity": "Junior Achievement",
    "spiderable": "all",
    "image": "/assets/themes/badges.ja.org/images/seo_image.png",
    "twitterSite": "JA_USA",
    "twitterCreator": "JA_USA",
    "app": "recipient-portal",
    "duplicateOf": "badges.ja.org",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.jascpa.ja.org"],
    "spotlightUrl": null
  },
  "credentials.itcilo.org": {
    "title": "ITCILO Credentials",
    "description": "ITCILO Credentials",
    "identity": "ITCILO",
    "spiderable": "all",
    "image": "/assets/themes/credentials.itcilo.org/images/seo_image.svg",
    "twitterSite": "@ITCILO",
    "twitterCreator": "@ITCILO",
    "app": "recipient-portal",
    "recipientPortalUrls": ["credentials.itcilo.org"],
    "spotlightUrl": null
  },
  "credentials.giesbusiness.illinois.edu": {
    "title": "Gies College of Business",
    "description": "Gies College of Business",
    "identity": "Gies College of Business",
    "spiderable": "all",
    "image": "",
    "twitterSite": "giesbusiness",
    "twitterCreator": "giesbusiness",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.giesbusiness.illinois.edu"],
    "spotlightUrl": null
  },
  "credentials.asme.org": {
    "title": "The American Society of Mechanical Engineers",
    "description": "ASME serves a wide-ranging engineering community through quality learning, the development of codes and standards, certifications, research, conferences and publications, government relations, and other forms of outreach.",
    "identity": "ASME serves a wide-ranging engineering community through quality learning, the development of codes and standards, certifications, research, conferences and publications, government relations, and other forms of outreach.",
    "spiderable": "all",
    "image": "/assets/themes/credentials.asme.org/images/seo_image.png",
    "twitterSite": "@ASMEdotorg",
    "twitterCreator": "ASME.org",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.asme.org"],
    "spotlightUrl": null
  },
  "certificates.directory.isa-arbor.com": {
    "title": "International Society of Arboriculture",
    "description": "International Society of Arboriculture",
    "identity": "International Society of Arboriculture",
    "spiderable": "all",
    "image": "/assets/themes/certificates.directory.isa-arbor.com/images/seo_image.png",
    "twitterSite": "ISAboriculture",
    "twitterCreator": "ISAboriculture",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "certificates.directory.isa-arbor.com"
  },
  "certified.coupa.com": {
    "title": "Coupa Digital Credentials",
    "description": "Coupa Digital Credentials",
    "identity": "Coupa Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/certified.coupa.com/images/seo_image.png",
    "twitterSite": "@Coupa",
    "twitterCreator": "@Coupa",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certified.coupa.com"],
    "spotlightUrl": null
  },
  "certificates.sandler.com": {
    "title": "Sandler Training Digital Credentials",
    "description": "Sandler Training Digital Credentials",
    "identity": "Sandler Training Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/certificates.sandler.com/images/seo_image.png",
    "twitterSite": "@SandlerTraining",
    "twitterCreator": "@SandlerTraining",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.sandler.com"],
    "spotlightUrl": null
  },
  "certificates.alphabest.org": {
    "title": "AlphaBEST",
    "description": "AlphaBEST",
    "identity": "AlphaBEST",
    "spiderable": "all",
    "image": "/assets/themes/certificates.alphabest.org/images/seo_image.png",
    "twitterSite": "@alphabestedu",
    "twitterCreator": "@alphabestedu",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.alphabest.org"],
    "spotlightUrl": null
  },
  "credentials.toasttab.com": {
    "title": "Toast",
    "description": "We empower the restaurant community to delight guests, do what they love, and thrive.",
    "identity": "Toast",
    "spiderable": "all",
    "image": "/assets/themes/credentials.toasttab.com/images/seo_image.png",
    "twitterSite": "@ToastTab",
    "twitterCreator": "@ToastTab",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.toasttab.com"],
    "spotlightUrl": null
  },
  "credentials.abbott.com": {
    "title": "Abbott Digital Credentials",
    "description": "Abbott Digital Credentials",
    "identity": "Abbott Digital Credentials",
    "spiderable": "all",
    "image": "/assets/themes/credentials.abbott.com/images/seo_image.png",
    "twitterSite": "@AbbottNews",
    "twitterCreator": "@AbbottNews",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.abbott.com"],
    "spotlightUrl": null
  },
  "certificates.wsetglobal.com": {
    "title": "WSET | Wine & Spirit Education Trust",
    "description": "Discover a world of knowledge with WSET's wine and spirit education and training courses, providing qualifications in wine training and spirit education.",
    "identity": "WSET | Wine & Spirit Education Trust",
    "spiderable": "all",
    "image": "/assets/themes/certificates.wsetglobal.com/images/seo_image.png",
    "twitterSite": "@WSETglobal",
    "twitterCreator": "@WSETglobal",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.wsetglobal.com"],
    "spotlightUrl": null
  },
  "certificates.thefundedtraderprogram.com": {
    "title": "The Funded Trader",
    "description": "The Funded Trader",
    "identity": "The Funded Trader",
    "spiderable": "all",
    "image": "/assets/themes/certificates.thefundedtraderprogram.com/images/seo_image.svg",
    "twitterSite": "@thefundedtrader",
    "twitterCreator": "@thefundedtrader",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.thefundedtraderprogram.com"],
    "spotlightUrl": null
  },
  "directory.thefundedtraderprogram.com": {
    "title": "The Funded Trader",
    "description": "The Funded Trader",
    "identity": "The Funded Trader",
    "spiderable": "all",
    "image": "/assets/themes/directory.thefundedtraderprogram.com/images/seo_image.svg",
    "twitterSite": "@thefundedtrader",
    "twitterCreator": "@thefundedtrader",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.thefundedtraderprogram.com"
  },
  "directory.vertimaxcertified.com": {
    "title": "Vertimax",
    "description": "Vertimax",
    "identity": "Vertimax",
    "spiderable": "all",
    "image": "/assets/themes/directory.vertimaxcertified.com/images/seo_image.png",
    "twitterSite": "TeamVertimax",
    "twitterCreator": "TeamVertimax",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.vertimaxcertified.com",
    "samlSsoUrl": ""
  },
  "credentialshub.toasttab.com": {
    "title": "Toast",
    "description": "We empower the restaurant community to delight guests, do what they love, and thrive.",
    "identity": "Toast",
    "spiderable": "all",
    "image": "/assets/themes/credentialshub.toasttab.com/images/seo_image.png",
    "twitterSite": "@ToastTab",
    "twitterCreator": "@ToastTab",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "credentialshub.toasttab.com"
  },
  "directory.tiktokcertified.com": {
    "title": "TikTok",
    "description": "TikTok's professional Certification program is the global standard for recognizing TikTok advertising expertise amongst marketing professionals. Become certified today to prove your TikTok knowledge and boost your credibility in market.",
    "identity": "TikTok",
    "spiderable": "all",
    "image": "/assets/themes/directory.tiktokcertified.com/images/seo_image.jpeg",
    "twitterSite": "@tiktok_us",
    "twitterCreator": "@tiktok_us",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.tiktokcertified.com"
  },
  "certificates.cloudbees.com": {
    "title": "Cloudbees",
    "description": "Cloudbees University",
    "identity": "Cloudbees University",
    "spiderable": "noindex, nofollow",
    "image": "/assets/themes/certificates.cloudbees.com/images/seo_image.png",
    "twitterSite": "@jenkinsci",
    "twitterCreator": "@jenkinsci",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.cloudbees.com"],
    "spotlightUrl": null
  },
  "aqa.accredible.com": {
    "title": "AQA",
    "description": "Digital Accreditation Badges for AQA Examiners & Moderators ",
    "identity": "AQA",
    "spiderable": "all",
    "image": "/assets/themes/aqa.accredible.com/images/seo_image.png",
    "twitterSite": "@AQA",
    "twitterCreator": "@AQA",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["aqa.accredible.com"],
    "spotlightUrl": null
  },
  "directory.fluencetraining.com": {
    "title": "Fluence Training",
    "description": "Fluence Training",
    "identity": "Fluence Training",
    "spiderable": "all",
    "image": "/assets/themes/directory.fluencetraining.com/images/seo_image.png",
    "twitterSite": "@Fluencetraining",
    "twitterCreator": "@Fluencetraining",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.fluencetraining.com"
  },
  "uclcertificates.dltscience.org": {
    "title": "DTL Science - University College London",
    "description": "Building Trust, Discovering Truth",
    "identity": "DTL Science",
    "spiderable": "all",
    "image": "/assets/themes/uclcertificates.dltscience.org/images/seo_image.png",
    "twitterSite": "@DLT_Science",
    "twitterCreator": "@DLT_Science",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["uclcertificates.dltscience.org"],
    "spotlightUrl": null
  },
  "credential.klaviyo.com": {
    "title": "Klaviyo Credentials",
    "description": "Klaviyo Credentials",
    "identity": "Klaviyo",
    "spiderable": "all",
    "image": "/assets/themes/credential.klaviyo.com/images/seo_image.jpg",
    "twitterSite": "@klaviyo",
    "twitterCreator": "@klaviyo",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credential.klaviyo.com"],
    "spotlightUrl": null
  },
  "credential.igsandpartners.com": {
    "title": "IGS&Partner",
    "description": "We build leaders who make a difference by providing state-of-the-art educational consulting and technology-driven learning solutions.",
    "identity": "IGS&Partner",
    "spiderable": "all",
    "image": "/assets/themes/credential.igsandpartners.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credential.igsandpartners.com"],
    "spotlightUrl": null
  },
  "chromeosandchromeenterprisecertifieddirectory.accredible.com": {
    "title": "Google Chrome Enteprise",
    "description": "With Chrome Enterprise, your users get the browser they already know and love with additional enterprise controls and security capabilities for your organisation.",
    "identity": "Google Chrome Enteprise",
    "spiderable": "all",
    "image": "/assets/themes/chromeosandchromeenterprisecertifieddirectory.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "chromeosandchromeenterprisecertifieddirectory.accredible.com"
  },
  "chromeenterprisecertified.accredible.com": {
    "title": "Google Chrome Enteprise",
    "description": "With Chrome Enterprise, your users get the browser they already know and love with additional enterprise controls and security capabilities for your organisation.",
    "identity": "Google Chrome Enteprise",
    "spiderable": "all",
    "image": "/assets/themes/chromeenterprisecertified.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["chromeenterprisecertified.accredible.com"],
    "spotlightUrl": null
  },
  "certificates.darwinbox.com": {
    "title": "Darwinbox",
    "description": "Darwinbox Academy Certification Program",
    "identity": "Darwinbox",
    "spiderable": "noindex, nofollow",
    "image": "/assets/themes/certificates.darwinbox.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.darwinbox.com"],
    "spotlightUrl": null
  },
  "credentials.offsec.com": {
    "title": "Offensive Security",
    "description": "Offensive Security",
    "identity": "Offensive Security",
    "spiderable": "all",
    "image": "/assets/themes/credentials.offsec.com/images/seo_image.png",
    "twitterSite": "@offsectraining",
    "twitterCreator": "@offsectraining",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.offsec.com"],
    "spotlightUrl": null
  },
  "cambridge.credential.getsmarter.com": {
    "title": "University of Cambridge Institute for Sustainability Leadership",
    "description": "University of Cambridge Institute for Sustainability Leadership",
    "identity": "University of Cambridge",
    "spiderable": "noindex, nofollow",
    "image": "/assets/themes/cambridge.credential.getsmarter.com/images/seo_image.png",
    "twitterSite": "@getsmarter",
    "twitterCreator": "@getsmarter",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["cambridge.credential.getsmarter.com"],
    "spotlightUrl": null
  },
  "oxford.credential.getsmarter.com": {
    "title": "University of Oxford",
    "description": "University of Oxford",
    "identity": "University of Oxford",
    "spiderable": "noindex, nofollow",
    "image": "/assets/themes/oxford.credential.getsmarter.com/images/seo_image.jpg",
    "twitterSite": "@getsmarter",
    "twitterCreator": "@getsmarter",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["oxford.credential.getsmarter.com"],
    "spotlightUrl": null
  },
  "sche.credential.getsmarter.com": {
    "title": "Get Smarter",
    "description": "Get Smarter",
    "identity": "Get Smarter",
    "spiderable": "noindex, nofollow",
    "image": "/assets/themes/sche.credential.getsmarter.com/images/seo_image.png",
    "twitterSite": "@getsmarter",
    "twitterCreator": "@getsmarter",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["sche.credential.getsmarter.com"],
    "spotlightUrl": null
  },
  "certificates.nexus.engin.umich.edu": {
    "title": "Michigan Engineering Nexus",
    "description": "Michigan Engineering Nexus",
    "identity": "Michigan Engineering Nexus",
    "spiderable": "all",
    "image": "/assets/themes/certificates.nexus.engin.umich.edu/images/seo_image.png",
    "twitterSite": "UMengineering",
    "twitterCreator": "UMengineering",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.nexus.engin.umich.edu"],
    "spotlightUrl": null,
    "samlSsoUrl": ""
  },
  "expertsdirectory.coupa.com": {
    "title": "Coupa Spotlight Directory",
    "description": "Coupa Spotlight Directory",
    "identity": "Coupa Spotlight Directory",
    "spiderable": "all",
    "image": "/assets/themes/expertsdirectory.coupa.com/images/seo_image.png",
    "twitterSite": "@coupa",
    "twitterCreator": "@coupa",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "expertsdirectory.coupa.com"
  },
  "professionals.offsec.com": {
    "title": "Offensive Security",
    "description": "Offensive Security",
    "identity": "Offensive Security",
    "spiderable": "all",
    "image": "/assets/themes/professionals.offsec.com/images/seo_image.png",
    "twitterSite": "@offsectraining",
    "twitterCreator": "@offsectraining",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "professionals.offsec.com"
  },
  "credentials.vetmed.illinois.edu": {
    "title": "University of Illinois College of Veterinary Medicine",
    "description": "University of Illinois College of Veterinary Medicine",
    "identity": "University of Illinois College of Veterinary Medicine",
    "spiderable": "all",
    "image": "/assets/themes/credentials.vetmed.illinois.edu/images/seo_image.jpg",
    "twitterSite": "Vet Med Illinois",
    "twitterCreator": "Vet Med Illinois",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.vetmed.illinois.edu"],
    "spotlightUrl": null
  },
  "training.apdt.com": {
    "title": "The Association For Professional Dog Training International",
    "description": "The Association For Professional Dog Training International",
    "identity": "The Association For Professional Dog Training International",
    "spiderable": "all",
    "image": "/assets/themes/training.apdt.com/images/seo_image.svg",
    "twitterSite": "APDT",
    "twitterCreator": "APDT",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "training.apdt.com"
  },
  "microcredentials.iastate.edu": {
    "title": "Iowa State University",
    "description": "Iowa State University",
    "identity": "Iowa State University",
    "spiderable": "all",
    "image": "/assets/themes/microcredentials.iastate.edu/images/seo_image.svg",
    "twitterSite": "@IowaStateU",
    "twitterCreator": "@IowaStateU",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["microcredentials.iastate.edu"],
    "spotlightUrl": null
  },
  "universityalliance.databricks.com": {
    "title": "Databricks University Alliance",
    "description": "All your data, analytics and AI on one Lakehouse platform",
    "identity": "Databricks",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@databricks",
    "twitterCreator": "@databricks",
    "app": "recipient-portal",
    "duplicateOf": "credentials.databricks.com",
    "languages": ["en"],
    "recipientPortalUrls": ["universityalliance.databricks.com"],
    "spotlightUrl": null
  },
  "uadirectory.databricks.com": {
    "title": "Databricks University Alliance",
    "description": "Databricks Certified Credential Holder Directory",
    "identity": "Databricks Certified Credential Holder Directory",
    "spiderable": "all",
    "image": "/assets/themes/directory.databrickscertified.com/images/seo_image.svg",
    "twitterSite": "@databricks",
    "twitterCreator": "@databricks",
    "app": "spotlight",
    "duplicateOf": "directory.databrickscertified.com",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "uadirectory.databricks.com"
  },
  "certificates.ece.org": {
    "title": "Educational Credential Evaluators",
    "description": "Educational Credential Evaluators",
    "identity": "Educational Credential Evaluators",
    "spiderable": "all",
    "image": "/assets/themes/certificates.ece.org/images/seo_image.png",
    "twitterSite": "ECEConnection",
    "twitterCreator": "ECEConnection",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.ece.org"],
    "spotlightUrl": null,
    "samlSsoUrl": ""
  },
  "directory.mpi.org": {
    "title": "MPI Directory",
    "description": "MPI Directory",
    "identity": "MPI Directory",
    "spiderable": "all",
    "image": "/assets/themes/directory.mpi.org/images/seo_image.png",
    "twitterSite": "@MPI",
    "twitterCreator": "@https://x.com/MPI",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.mpi.org"
  },
  "directory.mymedgas.com": {
    "title": "MyMedGas Directory ",
    "description": "MyMedGas Directory ",
    "identity": "MyMedGas Directory ",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.mymedgas.com/images/seo_image.webp",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.mymedgas.com"
  },
  "authorizations.psypact.gov": {
    "title": "Psypact",
    "description": "Psypact",
    "identity": "Psypact",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/authorizations.psypact.gov/images/seo_image.png",
    "twitterSite": "@PSYPACT",
    "twitterCreator": "@PSYPACT",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["authorizations.psypact.gov"],
    "spotlightUrl": null
  },
  "directory.psypact.gov": {
    "title": "PSYPACT DIRECTORY",
    "description": "PSYPACT DIRECTORY",
    "identity": "PSYPACT",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.psypact.gov/images/seo_image.png",
    "twitterSite": "PSYPACT",
    "twitterCreator": "PSYPACT",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.psypact.gov"
  },
  "directory.alphabest.org": {
    "title": "AlphaBEST",
    "description": "AlphaBEST",
    "identity": "AlphaBEST",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.alphabest.org/images/seo_image.png",
    "twitterSite": "AlphaBESTEdu",
    "twitterCreator": "AlphaBESTEdu",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.alphabest.org"
  },
  "certified.joinpavilion.com": {
    "title": "Pavilion",
    "description": "Pavilion",
    "identity": "Pavilion",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certified.joinpavilion.com/images/seo_image.png",
    "twitterSite": "@Join_Pavilion",
    "twitterCreator": "@Join_Pavilion",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certified.joinpavilion.com"],
    "spotlightUrl": null
  },
  "credentials.iup.edu": {
    "title": "Indiana University of Pennsylvania",
    "description": "Indiana University of Pennsylvania",
    "identity": "Indiana University of Pennsylvania",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.iup.edu/images/seo_image.svg",
    "twitterSite": "IUPedu",
    "twitterCreator": "IUPedu",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.iup.edu"],
    "spotlightUrl": null
  },
  "directory.naturallifemanship.com": {
    "title": "Natural Lifemanship",
    "description": "Natural Lifemanship",
    "identity": "Natural Lifemanship",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.naturallifemanship.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.naturallifemanship.com"
  },
  "membership-certificates.rcpi.ie": {
    "title": "Royal College of Physicians of Ireland",
    "description": "Royal College of Physicians of Ireland",
    "identity": "Royal College of Physicians of Ireland",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/membership-certificates.rcpi.ie/images/seo_image.png",
    "twitterSite": "https://x.com/RCPI_news",
    "twitterCreator": "https://x.com/RCPI_news",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["membership-certificates.rcpi.ie"],
    "spotlightUrl": null
  },
  "mybadges.cipd.org": {
    "title": "The Chartered Institute of Personnel and Development",
    "description": "CIPD stands for Chartered Institute of Personnel Development, and it's the organisation that sets professional standards for HR representatives.",
    "identity": "The Chartered Institute of Personnel and Development",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/mybadges.cipd.org/images/seo_image.png",
    "twitterSite": "@CIPD",
    "twitterCreator": "@CIPD",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["mybadges.cipd.org"],
    "spotlightUrl": null
  },
  "certificate.insead.edu": {
    "title": "INSEAD Online Programmes",
    "description": "INSEAD",
    "identity": "INSEAD",
    "spiderable": "noindex, nofollow",
    "samlSsoUrl": "",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificate.insead.edu"],
    "spotlightUrl": null
  },
  "credential.unrealengine.com": {
    "title": "Unreal Engine",
    "description": "Unreal Engine",
    "identity": "Unreal Engine",
    "spiderable": "all",
    "image": "/assets/themes/credential.unrealengine.com/images/seo_image.svg",
    "twitterSite": "unrealengine",
    "twitterCreator": "unrealengine",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credential.unrealengine.com"],
    "spotlightUrl": "credentialdirectory.unrealengine.com"
  },
  "credentialdirectory.unrealengine.com": {
    "title": "Unreal Engine",
    "description": "Unreal Engine",
    "identity": "Unreal Engine",
    "spiderable": "all",
    "image": "/assets/themes/credentialdirectory.unrealengine.com/images/seo_image.svg",
    "twitterSite": "unrealengine",
    "twitterCreator": "unrealengine",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["credential.unrealengine.com"],
    "spotlightUrl": "credentialdirectory.unrealengine.com"
  },
  "icpinspector.api.org": {
    "title": "American Petroleum Institute",
    "description": "American Petroleum Institute",
    "identity": "American Petroleum Institute",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/icpinspector.api.org/images/seo_image.png",
    "twitterSite": "APIenergy",
    "twitterCreator": "APIenergy",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["icpinspector.api.org"],
    "spotlightUrl": null
  },
  "team.accredible.com": {
    "title": "Accredible",
    "description": "Accredible",
    "identity": "Accredible",
    "spiderable": "all",
    "image": "/assets/themes/team.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "team.accredible.com"
  },
  "credentials.acs.org": {
    "title": "American Chemical Society",
    "description": "American Chemical Society",
    "identity": "American Chemical Society",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.acs.org/images/seo_image.png",
    "twitterSite": "@AmerChemSociety",
    "twitterCreator": "@AmerChemSociety",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.acs.org"],
    "spotlightUrl": null
  },
  "walmart.credential.net": {
    "title": "Walmart",
    "description": "Walmart Credentials",
    "identity": "Walmart",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/walmart.credential.net/images/seo_image.png",
    "twitterSite": "@WalmartInc",
    "twitterCreator": "@WalmartInc",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["walmart.credential.net"],
    "spotlightUrl": null
  },
  "directory.nationalinsuranceinstitute.com": {
    "title": "National Insurance Institute Directory",
    "description": "National Insurance Institute Directory",
    "identity": "National Insurance Institute Directory",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.nationalinsuranceinstitute.com/images/seo_image.png",
    "twitterSite": "@NII_Educate",
    "twitterCreator": "@NII_Educate",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.nationalinsuranceinstitute.com"
  },
  "certified.logicmonitor.com": {
    "title": "LogicMonitor",
    "description": "LogicMonitor",
    "identity": "LogicMonitor",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certified.logicmonitor.com/images/seo_image.png",
    "twitterSite": "LogicMonitor",
    "twitterCreator": "LogicMonitor",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certified.logicmonitor.com"],
    "spotlightUrl": null
  },
  "badges.hlag.com": {
    "title": "Hapag-Lloyd Credentials",
    "description": "Hapag-Lloyd AG is a German international shipping and container transportation company, the 5th biggest in the world. It was formed in 1970 through a merger of Hamburg-American Line and Norddeutscher Lloyd.",
    "identity": "Hapag-Lloyd Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/badges.hlag.com/images/seo_image.png",
    "twitterSite": "@HapagLloydAG",
    "twitterCreator": "@HapagLloydAG",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.hlag.com"],
    "spotlightUrl": null
  },
  "execedbadges.wharton.upenn.edu": {
    "title": "Wharton Executive Education",
    "description": "Wharton Executive Education",
    "identity": "Wharton Executive Education",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/execedbadges.wharton.upenn.edu/images/seo_image.png",
    "twitterSite": "Wharton Executive Education",
    "twitterCreator": "Wharton Executive Education",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["execedbadges.wharton.upenn.edu"],
    "spotlightUrl": null
  },
  "mycredentials.navc.com": {
    "title": "North American Veterinary Community | NAVC",
    "description": "North American Veterinary Community",
    "identity": "North American Veterinary Community",
    "spiderable": "all",
    "samlSsoUrl": "https://go.navc.com/certificates",
    "image": "/assets/themes/mycredentials.navc.com/images/seo_image.png",
    "twitterSite": "@The_NAVC",
    "twitterCreator": "@The_NAVC",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.navc.com"],
    "spotlightUrl": "mycredentials.navc.com"
  },
  "credential.aacsb.edu": {
    "title": "Association to Advance Collegiate Schools of Business",
    "description": "Association to Advance Collegiate Schools of Business",
    "identity": "Association to Advance Collegiate Schools of Business",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credential.aacsb.edu/images/seo_image.png",
    "twitterSite": "@AACSB",
    "twitterCreator": "@AACSB",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credential.aacsb.edu"],
    "spotlightUrl": null
  },
  "credentials.peo.on.ca": {
    "title": "PEO",
    "description": "PEO",
    "identity": "PEO",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.peo.on.ca/images/seo_image.png",
    "twitterSite": "@PEO_HQ",
    "twitterCreator": "@PEO_HQ",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.peo.on.ca"],
    "spotlightUrl": null
  },
  "credentials.technology.toasttab.com": {
    "title": "Toast",
    "description": "We empower the restaurant community to delight guests, do what they love, and thrive.",
    "identity": "Toast",
    "spiderable": "all",
    "image": "/assets/themes/credentials.technology.toasttab.com/images/seo_image.png",
    "twitterSite": "@ToastTab",
    "twitterCreator": "@ToastTab",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.technology.toasttab.com"],
    "spotlightUrl": null
  },
  "whitelabelstaging.accredible.com": {
    "title": "National Restaurant Association",
    "description": "National Restaurant Association",
    "identity": "National Restaurant Association",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/whitelabelstaging.accredible.com/images/seo_image.jpg",
    "twitterSite": "@WeRRestaurants",
    "twitterCreator": "@WeRRestaurants",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["whitelabelstaging.accredible.com"],
    "spotlightUrl": null
  },
  "credentials.charteredaccountantsanz.com": {
    "title": "Chartered Accountants Australia and New Zealand",
    "description": "Chartered Accountants Australia and New Zealand",
    "identity": "Chartered Accountants Australia and New Zealand",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.charteredaccountantsanz.com/images/seo_image.svg",
    "twitterSite": "Chartered Accountants Australia and New Zealand",
    "twitterCreator": "Chartered Accountants Australia and New Zealand",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.charteredaccountantsanz.com"],
    "spotlightUrl": null
  },
  "certificates.cyberbit.com": {
    "title": "Cybersecurity Certificates & Accreditations | Cyberbit",
    "description": "Obtain cybersecurity certificates and accreditation from Cyberbit, an industry leader in operational cyber readiness.",
    "identity": "Cyberbit",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certificates.cyberbit.com/images/seo_image.webp",
    "twitterSite": "@CYBERBITHQ",
    "twitterCreator": "@CYBERBITHQ",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.cyberbit.com"],
    "spotlightUrl": null
  },
  "certifications.polarisio.com": {
    "title": "Polaris I/O",
    "description": "Polaris I/O",
    "identity": "Polaris I/O",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certifications.polarisio.com/images/seo_image.png",
    "twitterSite": "@Polaris_HQ",
    "twitterCreator": "@Polaris_HQ",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.polarisio.com"],
    "spotlightUrl": null
  },
  "achievements.mntnuniversity.com": {
    "title": "Mountain",
    "description": "Mountain",
    "identity": "Mountain",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/achievements.mntnuniversity.com/images/seo_image.png",
    "twitterSite": "@weareMNTN",
    "twitterCreator": "@weareMNTN",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.mntnuniversity.com"],
    "spotlightUrl": null
  },
  "achievements.wharton.upenn.edu": {
    "title": "The Wharton School",
    "description": "The Wharton School",
    "identity": "The Wharton School",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/achievements.wharton.upenn.edu/images/seo_image.png",
    "twitterSite": "Wharton",
    "twitterCreator": "Wharton",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.wharton.upenn.edu"],
    "spotlightUrl": null
  },
  "achievements.accredible.com": {
    "title": "Accredible Internal Theme",
    "description": "Accredible",
    "identity": "Accredible",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.accredible.com"],
    "spotlightUrl": null
  },
  "partnerships.accredible.com": {
    "title": "Accredible PWL 2",
    "description": "Accredible",
    "identity": "Accredible",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["partnerships.accredible.com"],
    "spotlightUrl": null
  },
  "certifications.cribl.io": {
    "title": "Cribl University Digital Credentials",
    "description": "Cribl University Digital Credentials",
    "identity": "Cribl University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certifications.cribl.io/images/seo_image.png",
    "twitterSite": "@cribl_io",
    "twitterCreator": "@cribl_io",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certifications.cribl.io"],
    "spotlightUrl": null
  },
  "digitalcredentials.smith.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.smith.queensu.ca"],
    "spotlightUrl": null
  },
  "accredible.irc.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["accredible.irc.queensu.ca"],
    "spotlightUrl": null
  },
  "credentials.engineering.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.engineering.queensu.ca"],
    "spotlightUrl": null
  },
  "credentials.qsoe.educ.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.qsoe.educ.queensu.ca"],
    "spotlightUrl": null
  },
  "credentials.pros.educ.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.pros.educ.queensu.ca"],
    "spotlightUrl": null
  },
  "credentials.cte.educ.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.cte.educ.queensu.ca"],
    "spotlightUrl": null
  },
  "credentials.innovationcentre.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.innovationcentre.queensu.ca"],
    "spotlightUrl": null
  },
  "credentials.smith.queensu.ca": {
    "title": "Queen's University",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.smith.queensu.ca"],
    "spotlightUrl": null
  },
  "badges.trimble.com": {
    "title": "Trimble Badges | Showcase Your Trimble Certifications",
    "description": "Display and share your Trimble-issued certificates and achievements with confidence. Trimble Badges provide verified recognition of your technical expertise and professional growth.",
    "identity": "Trimble",
    "image": "/assets/themes/badges.trimble.com/images/seo_image.png",
    "twitterSite": "@TrimbleCorpNews",
    "twitterCreator": "@TrimbleCorpNews",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.trimble.com"],
    "spotlightUrl": null,
    "spiderable": "all",
    "samlSsoUrl": ""
  },
  "microcredentials.utmb.edu": {
    "title": "UTMB Health",
    "description": "UTMB Health",
    "identity": "UTMB Health",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/microcredentials.utmb.edu/images/seo_image.png",
    "twitterSite": "utmbhealth",
    "twitterCreator": "utmbhealth",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["microcredentials.utmb.edu"],
    "spotlightUrl": null
  },
  "abimcertified.abim.org": {
    "title": "American Board of Internal Medicine",
    "description": "ABIM is committed to improving the physician's experience with certification. We engage with physicians to shape better, more inclusive programs and products.",
    "identity": "American Board of Internal Medicine",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/abimcertified.abim.org/images/seo_image.svg",
    "twitterSite": "ABIMcert",
    "twitterCreator": "ABIMcert",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "abimcertified.abim.org"
  },
  "certificates.seas.upenn.edu": {
    "title": "Penn Engineering ",
    "description": "Penn Engineering is at the forefront of AI research, driving breakthroughs in robotics, machine learning and data science.",
    "identity": "Penn Engineering",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certificates.seas.upenn.edu/images/seo_image.png",
    "twitterSite": "PennEngineers",
    "twitterCreator": "PennEngineers",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.seas.upenn.edu"],
    "spotlightUrl": null
  },
  "servsafecreds.servsafebrands.com": {
    "title": "National Restaurant Association",
    "description": "National Restaurant Association",
    "identity": "National Restaurant Association",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/servsafecreds.servsafebrands.com/images/seo_image.jpg",
    "twitterSite": "@WeRRestaurants",
    "twitterCreator": "@WeRRestaurants",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["servsafecreds.servsafebrands.com"],
    "spotlightUrl": null
  },
  "credentials.mycollectivehub.com": {
    "title": "Collective by RAIS3 ",
    "description": "Collective by RAIS3 ",
    "identity": "Collective by RAIS3 ",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.mycollectivehub.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.mycollectivehub.com"],
    "spotlightUrl": null
  },
  "certificates.ope.engin.umich.edu": {
    "title": "Michigan Engineering Professional Education",
    "description": "Michigan Engineering Nexus",
    "identity": "Michigan Engineering Nexus",
    "spiderable": "all",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "duplicateOf": "certificates.nexus.engin.umich.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.ope.engin.umich.edu"],
    "spotlightUrl": null
  },
  "cred-ittest.adelphi.edu": {
    "title": "Adelphi University Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-ittest.adelphi.edu"],
    "spotlightUrl": null
  },
  "credentials.online.umich.edu": {
    "title": "UMich",
    "description": "Michigan Online Credentials",
    "identity": "UMich",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.online.umich.edu/images/seo_image.png",
    "twitterSite": "UMich",
    "twitterCreator": "UMich",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.online.umich.edu"],
    "spotlightUrl": null
  },
  "credentials.aba.com": {
    "title": "American Bankers Association",
    "description": "American Bankers Association",
    "identity": "American Bankers Association",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.aba.com/images/seo_image.svg",
    "twitterSite": "ABABankers",
    "twitterCreator": "ABABankers",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.aba.com"],
    "spotlightUrl": null
  },
  "education-credentials.bmc.com": {
    "title": "bmc",
    "description": "bmc credentials",
    "identity": "bmc credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/education-credentials.bmc.com/images/seo_image.svg",
    "twitterSite": "BMCSoftware",
    "twitterCreator": "BMCSoftware",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["education-credentials.bmc.com"],
    "spotlightUrl": null
  },
  "salesdemo.accredible.com": {
    "title": "Accredible Sales Demo Spotlight",
    "description": "Accredible",
    "identity": "Accredible",
    "spiderable": "all",
    "image": "/assets/themes/team.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "duplicateOf": "team.accredible.com",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "salesdemo.accredible.com"
  },
  "prostudies.badges.syr.edu": {
    "title": "Syracuse University Digital Credentials",
    "description": "Syracuse University Digital Credentials",
    "identity": "Syracuse University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/prostudies.badges.syr.edu/images/seo_image.png",
    "twitterSite": "@syracuseu",
    "twitterCreator": "@syracuseu",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["prostudies.badges.syr.edu"],
    "spotlightUrl": null
  },
  "certificates.law.ox.ac.uk": {
    "title": "University of Oxford - Faculty of Law",
    "description": "University of Oxford - Faculty of Law",
    "identity": "University of Oxford - Faculty of Law",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/certificates.law.ox.ac.uk/images/seo_image.jpg",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["certificates.law.ox.ac.uk"],
    "spotlightUrl": null
  },
  "partnercredentials.ukg.com": {
    "title": "UKG",
    "description": "UKG Partner Credentialing",
    "identity": "UKG Partner Credentialing",
    "image": "/assets/themes/partnercredentials.ukg.com/images/seo_image.png",
    "twitterSite": "UKGInc",
    "twitterCreator": "UKGInc",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["partnercredentials.ukg.com"],
    "spotlightUrl": null,
    "spiderable": "all",
    "samlSsoUrl": ""
  },
  "productbadging.ukg.com": {
    "title": "UKG Customer Credentialing",
    "description": "",
    "identity": "UKG Partners",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "duplicateOf": "partnercredentials.ukg.com",
    "languages": ["en"],
    "recipientPortalUrls": ["productbadging.ukg.com"],
    "spotlightUrl": null
  },
  "employeecredentials.ukg.com": {
    "title": "UKG Employee Credentialing",
    "description": "",
    "identity": "UKG Partners",
    "image": "",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "duplicateOf": "partnercredentials.ukg.com",
    "languages": ["en"],
    "recipientPortalUrls": ["employeecredentials.ukg.com"],
    "spotlightUrl": null
  },
  "cred-socialwork.adelphi.edu": {
    "title": "Adelphi University’s School of Social Work Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-socialwork.adelphi.edu"],
    "spotlightUrl": null
  },
  "cred-professional.adelphi.edu": {
    "title": "Adelphi University’s Professional & Continuing Studies Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-professional.adelphi.edu"],
    "spotlightUrl": null
  },
  "cred-career.adelphi.edu": {
    "title": "Adelphi University Center for Career and Professional Development Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-career.adelphi.edu"],
    "spotlightUrl": null
  },
  "faculty-excellence.adelphi.edu": {
    "title": "Adelphi University’s Faculty Center for Professional Excellence Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["faculty-excellence.adelphi.edu"],
    "spotlightUrl": null
  },
  "cred-business.adelphi.edu": {
    "title": "Adelphi University’s Robert B. Willumstad School of Business Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-business.adelphi.edu"],
    "spotlightUrl": null
  },
  "cred-hr.adelphi.edu": {
    "title": "Adelphi University’s Office of Human Resources Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-hr.adelphi.edu"],
    "spotlightUrl": null
  },
  "cred-alumni.adelphi.edu": {
    "title": "Adelphi University Alumni Relations Digital Credentials",
    "description": "Adelphi University Digital Credentials",
    "identity": "Adelphi University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/cred-ittest.adelphi.edu/images/seo_image.png",
    "twitterSite": "@AdelphiU",
    "twitterCreator": "@AdelphiU",
    "app": "recipient-portal",
    "duplicateOf": "cred-ittest.adelphi.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cred-alumni.adelphi.edu"],
    "spotlightUrl": null
  },
  "credentials.onlinecourses.smithschool.ox.ac.uk": {
    "title": "University of Oxford, Smith School of Enterprise & Environment Digital Credentials",
    "description": "University of Oxford, Smith School of Enterprise & Environment Digital Credentials",
    "identity": "@TheSmithSchool",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.onlinecourses.smithschool.ox.ac.uk/images/seo_image.svg",
    "twitterSite": "@TheSmithSchool",
    "twitterCreator": "@TheSmithSchool",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.onlinecourses.smithschool.ox.ac.uk"],
    "spotlightUrl": null
  },
  "credentials.fordham.edu": {
    "title": "Fordham University Digital Credentials",
    "description": "Fordham University Digital Credentials",
    "identity": "@FordhamNYC",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.fordham.edu/images/seo_image.png",
    "twitterSite": "@FordhamNYC",
    "twitterCreator": "@FordhamNYC",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.fordham.edu"],
    "spotlightUrl": null
  },
  "healthcommunication.badges.utexas.edu": {
    "title": "University of Texas at Austin",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["healthcommunication.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "digitalcredentials.queenslaw.ca": {
    "title": "Queen's University Faculty of Law",
    "description": "Queen's University Digital Credentials",
    "identity": "@queesu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/digitalcredentials.smith.queensu.ca/images/seo_image.jpg",
    "twitterSite": "@queensu",
    "twitterCreator": "@queensu",
    "app": "recipient-portal",
    "duplicateOf": "digitalcredentials.smith.queensu.ca",
    "languages": ["en"],
    "recipientPortalUrls": ["digitalcredentials.queenslaw.ca"],
    "spotlightUrl": null
  },
  "credentials.unity.edu": {
    "title": "Unity Environmental University ",
    "description": "",
    "identity": "Unity Environmental University - PWL",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/credentials.unity.edu/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["credentials.unity.edu"],
    "spotlightUrl": null
  },
  "verified.thepactinstitute.com": {
    "title": "The PACT Institute  Directory",
    "description": "The PACT Institute Digital Credentials",
    "identity": "The PACT Institute Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/verified.thepactinstitute.com/images/seo_image.png",
    "twitterSite": "DrStanTatkin",
    "twitterCreator": "DrStanTatkin",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["verified.thepactinstitute.com"],
    "spotlightUrl": null
  },
  "directory.thepactinstitute.com": {
    "title": "The PACT Institute Directory",
    "description": "The PACT Institute Directory",
    "identity": "The PACT Institute  Directory",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.thepactinstitute.com/images/seo_image.png",
    "twitterSite": "DrStanTatkin",
    "twitterCreator": "DrStanTatkin",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.thepactinstitute.com"
  },
  "directory.unity.edu": {
    "title": "Unity Environmental University Directory",
    "description": "Unity Environmental University",
    "identity": "Unity Environmental University",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/directory.unity.edu/images/seo_image.jpg",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "directory.unity.edu"
  },
  "acmedemo.accredible.com": {
    "title": "Acme Demo",
    "description": "Acme Demo",
    "identity": "Acme Demo",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/acmedemo.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["acmedemo.accredible.com"],
    "spotlightUrl": null
  },
  "academicaffairs.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["academicaffairs.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "healthipe.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["healthipe.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "professionaled.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["professionaled.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "cockrell.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cockrell.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "education.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["education.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "liberalarts.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["liberalarts.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "cns.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["cns.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "pharmacy.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["pharmacy.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "dellmed.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["dellmed.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "ehs.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["ehs.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "extendedcampus.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["extendedcampus.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "humanitiesinstitute.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["humanitiesinstitute.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "lbj.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["lbj.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "mccombs.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["mccombs.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "moody.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["moody.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "orsc.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["orsc.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "emergencymanagement.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["emergencymanagement.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "deanofstudents.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["deanofstudents.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "petex.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["petex.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "nursing.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["nursing.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "shift.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["shift.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "executiveengr.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["executiveengr.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "execed.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["execed.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "research.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["research.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "uln.badges.utexas.edu": {
    "title": "University of Texas at Austin Digital Credentials",
    "description": "University of Texas at Austin Digital Credentials",
    "identity": "University of Texas at Austin Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/healthcommunication.badges.utexas.edu/images/seo_image.png",
    "twitterSite": "utaustin",
    "twitterCreator": "utaustin",
    "app": "recipient-portal",
    "duplicateOf": "healthcommunication.badges.utexas.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["uln.badges.utexas.edu"],
    "spotlightUrl": null
  },
  "diplomasuao.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["diplomasuao.anahuac.mx"],
    "spotlightUrl": null
  },
  "credenciales.online.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "duplicateOf": "diplomasuao.anahuac.mx",
    "languages": ["en"],
    "recipientPortalUrls": ["credenciales.online.anahuac.mx"],
    "spotlightUrl": null
  },
  "diplomasuac.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "duplicateOf": "diplomasuao.anahuac.mx",
    "languages": ["en"],
    "recipientPortalUrls": ["diplomasuac.anahuac.mx"],
    "spotlightUrl": null
  },
  "diplomasmerida.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "duplicateOf": "diplomasuao.anahuac.mx",
    "languages": ["en"],
    "recipientPortalUrls": ["diplomasmerida.anahuac.mx"],
    "spotlightUrl": null
  },
  "diplomasiest.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "duplicateOf": "diplomasuao.anahuac.mx",
    "languages": ["en"],
    "recipientPortalUrls": ["diplomasiest.anahuac.mx"],
    "spotlightUrl": null
  },
  "diplomasuav.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "duplicateOf": "diplomasuao.anahuac.mx",
    "languages": ["en"],
    "recipientPortalUrls": ["diplomasuav.anahuac.mx"],
    "spotlightUrl": null
  },
  "programasidea.anahuac.mx": {
    "title": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "description": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "identity": "Otorgado por la Universidad Anáhuac de Oaxaca",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/diplomasuao.anahuac.mx/images/seo_image.png",
    "twitterSite": "redanahuac",
    "twitterCreator": "redanahuac",
    "app": "recipient-portal",
    "duplicateOf": "diplomasuao.anahuac.mx",
    "languages": ["en"],
    "recipientPortalUrls": ["programasidea.anahuac.mx"],
    "spotlightUrl": null
  },
  "achievements.quickframeacademy.com": {
    "title": "QuickFrame Credentials",
    "description": "QuickFrame Credentials",
    "identity": "QuickFrame Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/achievements.quickframeacademy.com/images/seo_image.png",
    "twitterSite": "weareMNTN",
    "twitterCreator": "weareMNTN",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["achievements.quickframeacademy.com"],
    "spotlightUrl": null
  },
  "badges.syr.edu": {
    "title": "Syracuse University Digital Credentials",
    "description": "Syracuse University Digital Credentials",
    "identity": "Syracuse University Digital Credentials",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/prostudies.badges.syr.edu/images/seo_image.png",
    "twitterSite": "@syracuseu",
    "twitterCreator": "@syracuseu",
    "app": "recipient-portal",
    "duplicateOf": "prostudies.badges.syr.edu",
    "languages": ["en"],
    "recipientPortalUrls": ["badges.syr.edu"],
    "spotlightUrl": null
  },
  "1edtech.accredible.com": {
    "title": "1EdTech + Accredible",
    "description": "1EdTech + Accredible",
    "identity": "1EdTech + Accredible",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/1edtech.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["1edtech.accredible.com"],
    "spotlightUrl": null
  },
  "gboedu.credential.net": {
    "title": "GBOedu",
    "description": "GBOedu Credentials",
    "identity": "GBOedu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/gboedu.credential.net/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "recipient-portal",
    "languages": ["en"],
    "recipientPortalUrls": ["gboedu.credential.net"],
    "spotlightUrl": null
  },
  "gboedu.accredible.com": {
    "title": "GBOedu",
    "description": "GBOedu Credentials",
    "identity": "GBOedu",
    "spiderable": "all",
    "samlSsoUrl": "",
    "image": "/assets/themes/gboedu.accredible.com/images/seo_image.png",
    "twitterSite": "@accredible",
    "twitterCreator": "@accredible",
    "app": "spotlight",
    "languages": ["en"],
    "recipientPortalUrls": [],
    "spotlightUrl": "gboedu.accredible.com"
  }
}
